export const isinBcMap = new Map([
  ['CH0106027144', 351],
  ['IE00B8BVCK12', 4],
  ['CH0139101593', 4],
  ['CH0445689208', 1703],
  ['CH0016999846', 4],
  ['ES0144580Y14', 1058],
  ['IE00B4BNMY34', 65],
  ['GB00B1XZS820', 361],
  ['LU2145462300', 1330],
  ['GB00B0BRN552', 361],
  ['RU000A0JNGA5', 549],
  ['PTOTEKOE0011', 16],
  ['IE00B0M62Q58', 1703],
  ['IE00BF1QPL78', 1703],
  ['ES0157097017', 1058],
  ['LU0846194776', 1703],
  ['DE000A1PHFF7', 44],
  ['LU0124384867', 1330],
  ['GB0001367019', 361],
  ['FR0010331421', 25],
  ['DE0007165631', 44],
  ['DE0008402215', 44],
  ['DE0005313704', 44],
  ['IE0004927939', 6902],
  ['NL0015000IY2', 38],
  ['BE0003717312', 6],
  ['LU0011963245', 349],
  ['SE0000872095', 53],
  ['CH0000816824', 4],
  ['LU0942970442', 4],
  ['IE00BYM11L64', 4],
  ['IE00B988C465', 4],
  ['CLP3615W1037', 84],
  ['CNE1000002M1', 104],
  ['JE00B24DK645', 361],
  ['CH0012138605', 4],
  ['JE00B24DK975', 6920],
  ['IE00B53H0131', 349],
  ['XS2338355105', 1330],
  ['CLP7847L1080', 84],
  ['FR0013403441', 17],
  ['XS1001749289', 2779],
  ['XS1456422135', 16],
  ['XS2292954893', 16],
  ['XS2226808082', 558],
  ['FR0010424135', 1703],
  ['RU000A0J2Q06', 549],
  ['XS1520899532', 6829],
  ['FR0000121485', 25],
  ['GB00BDGKMY29', 361],
  ['GB0008706128', 361],
  ['JP3740200005', 106],
  ['JP3386030005', 106],
  ['GRS323003012', 34],
  ['LU0046217351', 16],
  ['LU0864709349', 2779],
  ['GB00BDCPN049', 67],
  ['IE00BQQP9F84', 361],
  ['JP3993400005', 106],
  ['JP3672400003', 106],
  ['JP3203500008', 106],
  ['PTMEN0AE0005', 51],
  ['CH0012214059', 4],
  ['CH0435377954', 4],
  ['DE000SYM9999', 44],
  ['CLP3880F1085', 84],
  ['CH0012100191', 4],
  ['JP3404200002', 106],
  ['CH0012221716', 4],
  ['NL0000235190', 25],
  ['CLP763281068', 84],
  ['LU0328476410', 1703],
  ['PTZON0AM0006', 51],
  ['CH0102993182', 65],
  ['LU0569974404', 38],
  ['GB00B15KXP72', 6920],
  ['LU0376446257', 4],
  ['LU0078812822', 13],
  ['LR0008862868', 65],
  ['IE00BJ5JNY98', 1703],
  ['LU0329630999', 4],
  ['CL0000000423', 84],
  ['NL0000009165', 38],
  ['GB00B0H2K534', 361],
  ['IE00BDFBTQ78', 1703],
  ['ES0105022000', 1058],
  ['FR0014000MR3', 25],
  ['FR0000124141', 25],
  ['FR0013326246', 25],
  ['DE000KSAG888', 44],
  ['LU1879532940', 1703],
  ['IE00BYVJRP78', 361],
  ['NL0010558797', 38],
  ['IE00BYX8XC17', 1703],
  ['FR0011665280', 25],
  ['CH0032912732', 4],
  ['CL0002115716', 84],
  ['HK0941009539', 104],
  ['LU0072462343', 349],
  ['CY0200352116', 48],
  ['GB00BMTV7393', 361],
  ['IE00BDR55471', 1703],
  ['CH0183136008', 349],
  ['JP3651400008', 106],
  ['LU0072462426', 349],
  ['IE00BGQYRR35', 1703],
  ['GB0009223206', 361],
  ['AU00000ETHI8', 111],
  ['GB0047524268', 558],
  ['FR0014005HJ9', 25],
  ['DE000LB2CPE5', 16],
  ['GB00BDRHNP05', 653],
  ['GB0004082847', 361],
  ['NL0013267909', 38],
  ['FR001400AJ45', 25],
  ['LU0270904781', 2779],
  ['FR0000053035', 25],
  ['MXP225611567', 80],
  ['MXP320321310', 80],
  ['MX01GA000004', 80],
  ['MXP370641013', 80],
  ['MX01AL0C0004', 80],
  ['MXP001391012', 80],
  ['MXP001661018', 80],
  ['MX01AC100006', 80],
  ['IE00B5M1WJ87', 1703],
  ['FR0000121964', 25],
  ['IE0032077012', 361],
  ['DE000TUAG505', 44],
  ['DE000DTR0CK8', 44],
  ['CH0003541510', 4],
  ['AT0000KTMI02', 4],
  ['CH0010702154', 4],
  ['CH0006372897', 4],
  ['DE0007100000', 44],
  ['LU0153359632', 6184],
  ['DE000A3E5D64', 44],
  ['DE0007100000', 44],
  ['AT0000741053', 50],
  ['LU0383812293', 100],
  ['CH0039821084', 4],
  ['CH0030486770', 4],
  ['CH0011339204', 4],
  ['CH0024608827', 4],
  ['CH0025536027', 4],
  ['GB00BLGZ9862', 361],
  ['AU000000SPL0', 111],
  ['XS1993827135', 558],
  ['IE00BCRY6557', 1703],
  ['IT0004967292', 6921],
  ['LU2523866379', 361],
  ['LU0090865873', 1330],
  ['CH1169151003', 4],
  ['DE000KD88880', 17],
  ['IT0001078911', 6921],
  ['AU0000064966', 111],
  ['CH0454664043', 16],
  ['IE00B3VVMM84', 1703],
  ['XS1979262448', 16],
  ['MX01WA000038', 80],
  ['MX01OM000018', 80],
  ['MXP554091415', 80],
  ['MX01PI000005', 80],
  ['CH0002783535', 2779],
  ['LU0490618542', 719],
  ['GB00BMX86B70', 361],
  ['IE00BM67HM91', 1703],
  ['FR0000051807', 25],
  ['IE00B4PY7Y77', 361],
  ['LU1681037609', 25],
  ['IE00B3F81R35', 361],
  ['LU0231459107', 2779],
  ['LU0380865021', 1703],
  ['DE0007030009', 44],
  ['CNE100000114', 104],
  ['LU1738384764', 1100],
  ['FR0013176526', 25],
  ['CH0014345117', 4],
  ['LU0312383663', 1330],
  ['IE00BK5BQV03', 1703],
  ['IE00BK5BQX27', 365],
  ['GB00BMVP7Y09', 67],
  ['GB0009895292', 361],
  ['GB00BYRH4982', 361],
  ['LU0927735406', 361],
  ['CH0432492467', 4],
  ['LU0292107645', 1703],
  ['CH0012142631', 4],
  ['IE00B51B7Z02', 719],
  ['IE00B945VV12', 38],
  ['CH1134540470', 65],
  ['LU0292096186', 1703],
  ['JP3496400007', 106],
  ['BE0003565737', 6],
  ['JP3197800000', 106],
  ['JP3421800008', 106],
  ['FR0011726835', 25],
  ['IE00B4L5YC18', 361],
  ['GB00BD6P7Y24', 361],
  ['DE000A0S8488', 44],
  ['JE00B1VS2W53', 361],
  ['CH1134472625', 880],
  ['IE00BF2FN646', 6920],
  ['JP3188200004', 106],
  ['XS2271356201', 653],
  ['GB00BVFCZV34', 361],
  ['IE00B4L5YC18', 361],
  ['XS1888179550', 15],
  ['IE00BQQP9F84', 361],
  ['LU0235308482', 2779],
  ['FR0011449602', 13],
  ['GB00BD7V5D43', 361],
  ['IE00B9CQXS71', 1703],
  ['IE0008470928', 1703],
  ['FR0000060873', 25],
  ['ES0171743901', 1058],
  ['LU0252633754', 25],
  ['CH0012684657', 466],
  ['FR0000052292', 25],
  ['CLP9796J1008', 84],
  ['GB00B15KXQ89', 361],
  ['AT0000A18XM4', 4],
  ['IE00BKWQ0D84', 25],
  ['AU000000COH5', 111],
  ['AU000000RHC8', 111],
  ['CH0030380734', 4],
  ['DE000A1YCMM2', 2779],
  ['FR0011648971', 6808],
  ['ES0105495008', 5386],
  ['IE00B3Q19T94', 1703],
  ['LU0261948227', 13],
  ['LU0229940001', 2779],
  ['AU000000TOU2', 111],
  ['LU0188438112', 15],
  ['FR0013269123', 25],
  ['NL0000303709', 1573],
  ['IE00B6R52143', 361],
  ['IE00BWBXM278', 1703],
  ['LU0225737302', 349],
  ['ES0126501131', 1058],
  ['IE00B94ZB998', 1703],
  ['LU0270814014', 1330],
  ['IE00B4L5Y983', 1703],
  ['FR0000038242', 25],
  ['IE00BCHWNW54', 1703],
  ['IE00BGQYRS42', 1703],
  ['XS1718868307', 1330],
  ['IE00BGQYRQ28', 719],
  ['GB00B23K0M20', 361],
  ['IT0005218380', 6921],
  ['DE000PSM7770', 44],
  ['IE00B5M4WH52', 361],
  ['GB0002875804', 361],
  ['JE00BDD9QC84', 6920],
  ['GB00B2QPKJ12', 361],
  ['CL0002339605', 84],
  ['CH0012453913', 4],
  ['IE00BJ5JPG56', 1703],
  ['IE00B7WK2W23', 349],
  ['LU0514695690', 719],
  ['IE00B0M62S72', 38],
  ['NO0010564701', 48],
  ['XS1247736793', 41],
  ['NL0006237562', 38],
  ['DE0005933931', 1703],
  ['LU0090689299', 16],
  ['LU1819480192', 2779],
  ['LU2523865991', 361],
  ['LU0329678410', 1330],
  ['IE00BMG6Z448', 38],
  ['LU0438336264', 2779],
  ['LU0329760770', 2779],
  ['LU2009202107', 1703],
  ['LU2009202107', 1703],
  ['IE00B0M63177', 719],
  ['IE00B652H904', 1703],
  ['IE00B0M63516', 1703],
  ['IE00B579F325', 361],
  ['IE00B0M63623', 719],
  ['IE00B1TXK627', 1703],
  ['CH0237935652', 4],
  ['NO0005052605', 48],
  ['CH0030170408', 4],
  ['AU0000028946', 111],
  ['GB00BGXQNP29', 361],
  ['GB00BNC5T391', 361],
  ['GB00BF5H9P87', 361],
  ['FR0000131104', 25],
  ['LU0136240974', 352],
  ['AU000000IGO4', 111],
  ['IT0005377277', 5493],
  ['LU0070848972', 17],
  ['LU0099574567', 1330],
  ['LU0200076213', 17],
  ['GB0008481250', 361],
  ['PA1436583006', 65],
  ['IE00B4ZJ4188', 1330],
  ['IE00BCRY5Y77', 361],
  ['IE00BYM11J43', 349],
  ['IE00BGSF1X88', 361],
  ['CY0102102213', 699],
  ['PTEDP0AM0009', 51],
  ['LU0128522157', 349],
  ['GB00B0130H42', 361],
  ['DE0006766504', 44],
  ['LU1598757687', 38],
  ['FR0000064578', 25],
  ['PLOPTTC00011', 243],
  ['GB00B15KXS04', 106],
  ['CH0035657417', 880],
  ['RU0007661625', 549],
  ['PTSON0AM0001', 51],
  ['FR0000125585', 25],
  ['JP3304200003', 106],
  ['SE0009922164', 53],
  ['SE0000106270', 53],
  ['GB00B15KXV33', 6920],
  ['NO0003054108', 48],
  ['GB00B15KY542', 6920],
  ['IE00BD8PGZ49', 351],
  ['LU0838782315', 1703],
  ['GG00BMX4VR69', 361],
  ['IE00B5SG8Z57', 361],
  ['IE00BY7QL619', 65],
  ['IE00B5KQNG97', 361],
  ['IE00B14X4N27', 361],
  ['IE00BYXYYP94', 361],
  ['IE00B42TW061', 699],
  ['CH0022268228', 4],
  ['CH0048265513', 65],
  ['LU0584671464', 65],
  ['CH0012255144', 4],
  ['LU0048578792', 1330],
  ['NL0000009827', 365],
  ['ES0105025003', 1058],
  ['FR0000033599', 6808],
  ['JP3522600000', 106],
  ['CH0360674466', 4],
  ['LU0048621477', 16],
  ['CH0038389992', 4],
  ['LU0095938881', 2913],
  ['IE00B4694Z11', 361],
  ['DE000LED4000', 17],
  ['AEDFXA14NUL7', 824],
  ['NL0011794037', 38],
  ['IT0003132476', 6921],
  ['IE00B3VWMM18', 1703],
  ['DE0006048432', 44],
  ['NL0000379121', 38],
  ['CH0311864901', 4],
  ['IE00BCLWRD08', 1703],
  ['XS2411537033', 653],
  ['NL0011821202', 38],
  ['GB00B5ZN1N88', 361],
  ['IE00BZCQB185', 719],
  ['LU0207432559', 16],
  ['DE000DL19WG7', 16],
  ['LU0046676465', 2779],
  ['ES0105093001', 5386],
  ['LU0217139020', 14],
  ['GB00B24CGK77', 361],
  ['CH0109967858', 349],
  ['IL0011582033', 65],
  ['AU0000139990', 63],
  ['IE00B3VWM098', 1703],
  ['CH0023868554', 4],
  ['FR0011053636', 6808],
  ['JP3399310006', 106],
  ['LU0255798109', 16],
  ['IE00BWBXM492', 361],
  ['IE00BWBXM617', 361],
  ['AT0000743059', 50],
  ['DK0060534915', 1573],
  ['XS1707063589', 653],
  ['FR0010095596', 6808],
  ['LU0318931192', 1330],
  ['LU0507265923', 13],
  ['DE0007297004', 44],
  ['LU0164455502', 14],
  ['NL0000009538', 38],
  ['IE00B9MRJJ36', 1703],
  ['IE00B3VWN518', 361],
  ['XS1793255941', 653],
  ['CH0011075394', 4],
  ['IL0011284465', 361],
  ['LU0056508442', 1330],
  ['IE00B3YC1100', 361],
  ['IE00B6R51Z18', 719],
  ['LU0395794307', 16],
  ['IE00B4JNQZ49', 361],
  ['LU0187077481', 1330],
  ['DE000UNSE018', 2779],
  ['LU0823401574', 1330],
  ['FR0006174348', 25],
  ['FR0011464452', 6808],
  ['AU000000BHP4', 111],
  ['LU0077335932', 2779],
  ['LU0029875118', 2779],
  ['FR0010533075', 25],
  ['AU000000ATC9', 111],
  ['LU0141799097', 1330],
  ['LU1598689153', 25],
  ['JE00B78CGV99', 361],
  ['AU000000SAU3', 111],
  ['LU1900068914', 6920],
  ['CLP3064M1019', 84],
  ['LU0328475792', 1703],
  ['BE0003797140', 6],
  ['CH0334081137', 67],
  ['CH0012255151', 4],
  ['LU0128467544', 1330],
  ['XS1115184753', 41],
  ['CH0009691608', 4],
  ['LU0950674761', 351],
  ['IE00BKVL7D31', 1703],
  ['IE00BKVL7331', 1703],
  ['IE00BYM11H29', 349],
  ['IE00BHXMHL11', 349],
  ['JP3436100006', 106],
  ['IE00BF2QSQ20', 361],
  ['CL0000000100', 84],
  ['DE000A1KJHG8', 13],
  ['GG00BGDYDZ69', 361],
  ['CH0038863350', 4],
  ['CH0011484067', 4],
  ['JE00BYSS4X48', 67],
  ['DE0006289309', 1703],
  ['GB00B1FW5029', 361],
  ['LU1048317538', 5382],
  ['FR0000130452', 25],
  ['IE00B6YX5C33', 719],
  ['IE00B42NKQ00', 361],
  ['GB0003096442', 361],
  ['CH0139101601', 4],
  ['GB0003887287', 361],
  ['FR0000131906', 25],
  ['LI0008232220', 1330],
  ['GB00B15KY104', 6920],
  ['GB00B15KY658', 1703],
  ['IE00B6YX5D40', 719],
  ['CH0126881561', 4],
  ['LU1006510504', 2779],
  ['IE00B3WJKG14', 1703],
  ['XS1190974011', 653],
  ['FR0013479276', 13],
  ['XS1538284230', 6915],
  ['LU1822773716', 1330],
  ['LU0319687124', 1330],
  ['GB00B06QFB75', 361],
  ['LU0823426308', 1330],
  ['CH0360826991', 4],
  ['CH1101098163', 4],
  ['XS1826622240', 558],
  ['IE00BP9F2H18', 361],
  ['IE00B4L5YX21', 361],
  ['DE0005156004', 2779],
  ['IE00B3YCGJ38', 361],
  ['NL0000226223', 6921],
  ['AU000000IEL5', 111],
  ['GB0030913577', 361],
  ['GB0004915632', 361],
  ['DE0008404005', 44],
  ['IE00BYZK4552', 1703],
  ['IE00BMH5Y871', 719],
  ['CH1169360919', 4],
  ['JP3771800004', 106],
  ['GB0033195214', 361],
  ['DK0010274414', 12],
  ['CH0042615283', 4],
  ['FR0004163111', 25],
  ['LU1279333675', 349],
  ['LU1564329115', 1330],
  ['IE00BJJYYX67', 80],
  ['XS1280834992', 41],
  ['IE00BYXYYN70', 365],
  ['ES0113900J37', 1058],
  ['CH0286864027', 558],
  ['IE00BGV5VM45', 1703],
  ['GB0002945029', 361],
  ['LU1834983477', 25],
  ['LU1829221024', 1703],
  ['CH0104136319', 351],
  ['FR0000073298', 25],
  ['IE00B945VV12', 38],
  ['IT0000062072', 6921],
  ['IE00B02KXH56', 6920],
  ['IE00B1FZS244', 1703],
  ['FR0010321810', 1330],
  ['FR0011341205', 25],
  ['IT0004965148', 6921],
  ['CH0014852781', 4],
  ['FR0013227113', 25],
  ['FR0000120578', 25],
  ['SG1S83002349', 120],
  ['LU0226953718', 349],
  ['IT0000072618', 6921],
  ['ES0178430E18', 1058],
  ['LU0323578657', 1330],
  ['DE0005785604', 44],
  ['DE0007236101', 44],
  ['LU0203975437', 18],
  ['XS1713469911', 558],
  ['LU1829219390', 25],
  ['ES0166300212', 1058],
  ['CH0102993182', 65],
  ['LU0212925753', 1330],
  ['IT0005347429', 6921],
  ['NL0011821392', 38],
  ['LU0380865021', 1703],
  ['FR0000073272', 25],
  ['DE0005552004', 44],
  ['IE00BCHWNT26', 361],
  ['LU0044957727', 18],
  ['GB00BFWFPL34', 16],
  ['XS2031976678', 16],
  ['LU0227384020', 351],
  ['FR0000130692', 25],
  ['XS2325696628', 653],
  ['LU0106259558', 2779],
  ['DE000A0H0728', 1703],
  ['GB0030232317', 361],
  ['AT0000A21KS2', 50],
  ['FR0010609263', 6808],
  ['FR0000074783', 25],
  ['FR0010655746', 25],
  ['GB00B7KR2P84', 361],
  ['LU1681043599', 25],
  ['NZXROE0001S2', 111],
  ['GB0031348658', 361],
  ['IT0005254252', 5493],
  ['IT0005378143', 5493],
  ['LU0952581584', 352],
  ['XS2088650051', 41],
  ['XS2124192654', 653],
  ['IE00BP3QZB59', 719],
  ['JE00B2NFTW01', 361],
  ['ES0105046009', 1058],
  ['CH0012335540', 4],
  ['CH0102484968', 4],
  ['LU0055631609', 349],
  ['CH0432492467', 4],
  ['GB00BYN5YK77', 699],
  ['LU0202403266', 1330],
  ['LU0171301533', 16],
  ['SG1L01001701', 120],
  ['DE0005140008', 44],
  ['DE000FTG1111', 44],
  ['CH0012627250', 4],
  ['AU000000SUN6', 111],
  ['GB00B0744359', 361],
  ['JP3027630007', 106],
  ['LU0326422689', 1330],
  ['DE0006231004', 44],
  ['GB00B0744B38', 361],
  ['JP3027650005', 106],
  ['IE00BD1DJ122', 13],
  ['SE0015810247', 53],
  ['IE00BFRT3W74', 65],
  ['DE0007164600', 44],
  ['IE00BKWQ0J47', 25],
  ['XS1085735899', 41],
  ['LU0292100806', 1703],
  ['IE00BLNMYC90', 361],
  ['IE00BKWQ0H23', 25],
  ['IE00BKWQ0P07', 25],
  ['IE00BG7PP820', 361],
  ['XS1662406468', 558],
  ['IE00B5MTXJ97', 1703],
  ['IE00B0M63284', 38],
  ['IE00B00FV128', 361],
  ['LU1781541252', 1703],
  ['IL0010823792', 105],
  ['GB00BH4HKS39', 361],
  ['LU0104884605', 13],
  ['GB00B019KW72', 361],
  ['IE00B14X4T88', 6920],
  ['GB00BGCYZL73', 699],
  ['FR0000035818', 6808],
  ['DK0060227585', 12],
  ['GB0007980591', 361],
  ['IE00B5BMR087', 361],
  ['DE0007664005', 44],
  ['FR0010908723', 6808],
  ['NL0014559478', 25],
  ['LU1681037948', 25],
  ['DE0007664039', 44],
  ['CH0263939958', 466],
  ['LU1785301513', 349],
  ['IE00BYZK4883', 1703],
  ['FR0000053506', 25],
  ['IE00BD3V0B10', 1703],
  ['JP3242800005', 106],
  ['IE000ZPUEP93', 38],
  ['LU1681048630', 25],
  ['IE00B1FZSF77', 719],
  ['GB00BV9FP302', 361],
  ['ES0169501022', 1058],
  ['GB00B684MW17', 361],
  ['LU0053685615', 2779],
  ['LU0090784017', 1330],
  ['DK0060946788', 12],
  ['AU000000WES1', 111],
  ['AU000000RMD6', 111],
  ['GB0006731235', 361],
  ['DE0007480204', 44],
  ['XS1629774230', 1330],
  ['FR0000133308', 25],
  ['IE00B95PGT31', 719],
  ['CH0012268360', 4],
  ['IE00BYZK4776', 1703],
  ['CH0271428333', 558],
  ['DE000KC01000', 44],
  ['XS1686704948', 558],
  ['XS1684384511', 558],
  ['XS0207764712', 1330],
  ['FR0010135103', 1330],
  ['XS1046224884', 558],
  ['GB00B15KYH63', 361],
  ['HK0253001314', 104],
  ['CH0019852802', 4],
  ['IE00BC7GZX26', 361],
  ['NL0009538784', 67],
  ['CH0010645932', 4],
  ['DE0001104867', 16],
  ['CH0010570759', 4],
  ['IE0008471009', 6920],
  ['GG00BMGYLN96', 361],
  ['SE0010296582', 1010],
  ['FR0000130577', 25],
  ['CH0001234068', 4],
  ['GB00BLBDX619', 16],
  ['FR0000125338', 25],
  ['XS1799614232', 558],
  ['IE00B5L01S80', 1703],
  ['LU1681047236', 25],
  ['FR0012399806', 361],
  ['FR0000120172', 25],
  ['XS2025575114', 558],
  ['AU0000185597', 111],
  ['MXP4948K1056', 80],
  ['MXP370841019', 80],
  ['MXP370711014', 80],
  ['MX01HC000001', 80],
  ['IE00B6SPMN59', 719],
  ['SG1T75931496', 120],
  ['LU1778762911', 65],
  ['CH0127181177', 4],
  ['IE00B95PGT31', 719],
  ['CL0002841873', 84],
  ['LU0125951151', 351],
  ['IE00B53QDK08', 80],
  ['IE00B53QG562', 6920],
  ['PAL1801171A1', 89],
  ['FR0000125007', 25],
  ['IE00BLNN3691', 67],
  ['XS1753595328', 558],
  ['CH1175448666', 4],
  ['CH0039651184', 4],
  ['XS1893631330', 16],
  ['IE00BM67HK77', 1703],
  ['XS1431730388', 16],
  ['JE00B4T3BW64', 361],
  ['LU0273158872', 2779],
  ['DE0007257503', 44],
  ['IE00BG21M733', 361],
  ['CH0237935637', 4],
  ['IE00BKWQ0G16', 25],
  ['DE000A0D9PT0', 44],
  ['CH0008038389', 4],
  ['SG1N31909426', 120],
  ['ES0173093024', 1058],
  ['ES0124244E34', 1058],
  ['DE000ENER6Y0', 44],
  ['FI0009005961', 40],
  ['IE00B5SSQT16', 361],
  ['CY0109232112', 34],
  ['BE0974276082', 6],
  ['LU0908500753', 1703],
  ['LU1834988864', 6920],
  ['LU1834988518', 25],
  ['ES0105027009', 1058],
  ['LU1834986900', 25],
  ['IE00BFYTYS33', 361],
  ['GB00BM8Z2S21', 361],
  ['LU0345361124', 1330],
  ['FR0000054900', 25],
  ['IL0010824113', 67],
  ['IE00BMPRXN33', 349],
  ['IM00B5VQMV65', 361],
  ['CH0131872431', 4],
  ['LU1834985845', 6920],
  ['DE0005933956', 1703],
  ['SG1R50925390', 120],
  ['LU0114722498', 351],
  ['SG1I55882803', 120],
  ['GB00B10RZP78', 361],
  ['FR0000130403', 25],
  ['PTREL0AM0008', 51],
  ['LU1775965582', 1330],
  ['FR0000121667', 25],
  ['GB00BDSFG982', 65],
  ['IE00B86MWN23', 1590],
  ['IE00BM67HT60', 1703],
  ['FR0000051070', 25],
  ['IE00BYPLS672', 6920],
  ['CH0025751329', 4],
  ['IE00BFZPF546', 361],
  ['LU0243957825', 2779],
  ['ES0139140174', 1058],
  ['NL0000009082', 38],
  ['IE00BYXYYJ35', 361],
  ['IE00BYPC1H27', 6920],
  ['GB0006215205', 361],
  ['LU0292106241', 1703],
  ['JP3101600009', 106],
  ['FR0010296061', 1703],
  ['DE0008430026', 44],
  ['IE0005042456', 361],
  ['GB0004544929', 361],
  ['FR0012757854', 25],
  ['JE00B55Q3P39', 361],
  ['FR0000130809', 25],
  ['XS2466172280', 6829],
  ['XS2147889690', 16],
  ['XS2438615606', 16],
  ['XS2152795709', 13],
  ['XS1733289406', 653],
  ['XS2177364390', 653],
  ['XS2200244072', 16],
  ['LU0180781048', 1330],
  ['IM00B7S9G985', 361],
  ['FI0009007694', 40],
  ['IE00BJ38QD84', 361],
  ['CH0454664001', 349],
  ['IE00B3XXRP09', 719],
  ['GB00B125SX82', 361],
  ['DE000A0D8QZ7', 1703],
  ['FR0012333284', 25],
  ['FR0000120271', 25],
  ['JP3973400009', 106],
  ['AU000000STO6', 111],
  ['FR0010307819', 25],
  ['AU000000WBC1', 111],
  ['JP3435000009', 106],
  ['BE6265142099', 2779],
  ['XS2125052261', 558],
  ['CH0044781141', 349],
  ['LU0249326488', 1703],
  ['LU0189893794', 13],
  ['JE00B1VS3333', 6920],
  ['CH0244767585', 4],
  ['IE00B5WHFQ43', 361],
  ['NL0012059018', 38],
  ['FR0011184241', 25],
  ['GB00B39J2M42', 361],
  ['ZAE000170049', 100],
  ['LU0191819951', 1330],
  ['ARARGE3209S6', 82],
  ['BE0944264663', 3015],
  ['CH0023405456', 4],
  ['FR0000074148', 25],
  ['JE00B8KF9B49', 361],
  ['CH0038388911', 4],
  ['FR0000031684', 25],
  ['DE0006062144', 44],
  ['XS1201001572', 13],
  ['ES0105066007', 1058],
  ['CNE1000002H1', 104],
  ['FR0000140014', 25],
  ['MXP369181377', 80],
  ['LU0594300096', 17],
  ['ES0105425005', 5386],
  ['DE0007037129', 44],
  ['NL0012866412', 38],
  ['DE0008303504', 44],
  ['DE0005810055', 44],
  ['CH0008742519', 4],
  ['GB0005603997', 361],
  ['GB00BZ15CS02', 361],
  ['LU0210529656', 17],
  ['BE0974258874', 6],
  ['CH1256740924', 4],
  ['LU1756447840', 65],
  ['GB00B0FVQX23', 361],
  ['CNE100000569', 104],
  ['IT0003128367', 6921],
  ['JP3436120004', 106],
  ['IE00BGH1M568', 65],
  ['GB0030927254', 361],
  ['ARP2354W1188', 82],
  ['XS0210976329', 558],
  ['LU0703711035', 2779],
  ['AU000000ALL7', 111],
  ['LU1650492173', 361],
  ['CH0012214059', 4],
  ['GB00BBT32N39', 361],
  ['XS2385150334', 16],
  ['LU1681042948', 25],
  ['GB0000456144', 361],
  ['CH0012410517', 4],
  ['LU0159201655', 351],
  ['DE0005439004', 44],
  ['FR0010411983', 25],
  ['FR0010208488', 25],
  ['FR0000063935', 25],
  ['FR0000120073', 25],
  ['GB00B15KXN58', 6920],
  ['ES0105407003', 5386],
  ['FR0000120321', 25],
  ['XS1576621632', 653],
  ['CH0419042491', 4],
  ['DE0006602006', 44],
  ['FR0005175080', 25],
  ['IE00BSKRJZ44', 361],
  ['IE00BQ1YBR67', 15],
  ['JE00B1VS3770', 361],
  ['IE00B02KXL92', 1703],
  ['IE00B3T9LM79', 1703],
  ['IE00B8CJW150', 1703],
  ['FR0000032526', 25],
  ['IE00BCHWNV48', 361],
  ['DE0005565204', 44],
  ['CH0363463438', 4],
  ['BE0974293251', 6],
  ['IE00BK72HH44', 2779],
  ['CH0103326762', 351],
  ['IT0003796171', 6921],
  ['DE000SHL1006', 44],
  ['FR0013154002', 25],
  ['IT0000072170', 6921],
  ['IT0003492391', 6921],
  ['FR0000130213', 25],
  ['IE00BL977C92', 38],
  ['FR0010828137', 25],
  ['FR0010220475', 25],
  ['FR0000121204', 25],
  ['XS0989359756', 558],
  ['LU0274209740', 1703],
  ['FR0000121014', 25],
  ['GB0009619924', 361],
  ['FR0010259150', 25],
  ['FR0010221234', 25],
  ['ES0113211835', 1058],
  ['FR0010908533', 25],
  ['IE00B5MTWD60', 1703],
  ['LU1861132840', 1703],
  ['LU0224105477', 351],
  ['FR0000120693', 25],
  ['IE00BJXT3B87', 1703],
  ['FR0010397232', 6808],
  ['FR0013477254', 653],
  ['CH0114405324', 65],
  ['IE00B44CGS96', 361],
  ['FR0000125486', 25],
  ['DE000BAY0017', 44],
  ['IE00BTN1Y115', 65],
  ['DE000BASF111', 44],
  ['NL0000687663', 65],
  ['XS2296203123', 15],
  ['AU000000SLX4', 111],
  ['JE00BN574F90', 361],
  ['FR0000121220', 25],
  ['FR0010907956', 6808],
  ['IE00BCRY6227', 361],
  ['FR0000121972', 25],
  ['LU0498180339', 13],
  ['AU000000PEK2', 111],
  ['LU0979892907', 5382],
  ['CH0225173167', 4],
  ['ES0109067019', 1058],
  ['XS0213101073', 653],
  ['GB00B0CY5V57', 361],
  ['IE00B52MJY50', 361],
  ['CH0270190983', 4],
  ['ARARGE3209U2', 591],
  ['ARARGE3209Y4', 590],
  ['GB00B45C9X44', 361],
  ['GB0009887422', 1341],
  ['CH0002432174', 4],
  ['LU0322253906', 1703],
  ['GB0007973794', 361],
  ['IE00B00MZ448', 361],
  ['GB00B11SZ269', 361],
  ['CNE100000338', 104],
  ['NL0011585146', 6921],
  ['FR0010557264', 25],
  ['IE00BFNNN012', 361],
  ['LU0410959117', 1330],
  ['ES0173516115', 1058],
  ['CH1280433827', 880],
  ['TW0002454006', 103],
  ['GB0002374006', 361],
  ['FR0000036816', 25],
  ['CNE100000312', 104],
  ['IT0003261697', 6921],
  ['XS2043678841', 653],
  ['XS1428771809', 16],
  ['LU0274209740', 1703],
  ['GB00B1YW4409', 361],
  ['CH0127480363', 4],
  ['CH0226976816', 4],
  ['GB00B19NLV48', 361],
  ['XS0162513211', 16],
  ['IE00B2QWCY14', 1703],
  ['AU000000SES9', 111],
  ['IE00B02KXM00', 1703],
  ['LU1169822779', 349],
  ['LU0274209237', 1703],
  ['LU1184092051', 361],
  ['DE000A0H08H3', 1703],
  ['IE00BG0J4C88', 1703],
  ['DE000A0Q4R28', 1703],
  ['GB0031215220', 361],
  ['DE000A0H08S0', 1703],
  ['DE000A0H08G5', 1703],
  ['AU000000SHO1', 111],
  ['ES0112501012', 1058],
  ['FR0000033219', 25],
  ['LU1681037864', 25],
  ['CNE100000Q35', 104],
  ['CH0104136236', 349],
  ['LU0292454872', 349],
  ['AT0000A18XM4', 4],
  ['FR0011271600', 25],
  ['LU0255977455', 18],
  ['IL0011267213', 67],
  ['LU1169819635', 4],
  ['LU0067412154', 349],
  ['GB00B15KYG56', 6920],
  ['IE00B4L5ZY03', 1703],
  ['CH0036942719', 880],
  ['IE00BNC1G707', 361],
  ['XS2177363665', 653],
  ['IE00B42YS929', 361],
  ['IE00B4YBJ215', 361],
  ['IE00B2NPKV68', 361],
  ['FI0009000681', 40],
  ['IE00BDR55364', 4],
  ['DE0006969603', 44],
  ['CH0466642201', 4],
  ['GB0006825383', 361],
  ['LU0533033238', 1703],
  ['CH0012005267', 4],
  ['LU0029871042', 1330],
  ['DE000WAF3001', 44],
  ['AU000000TOU2', 111],
  ['LU1681042609', 6920],
  ['FR0014004L86', 25],
  ['IE00BCRY6003', 361],
  ['CH0012032048', 4],
  ['LU0636969866', 4],
  ['FR0000039299', 25],
  ['LU0210072939', 1330],
  ['PTCTT0AM0001', 51],
  ['LU0431992006', 349],
  ['IE00BG04M077', 1703],
  ['IE00B4K48X80', 1703],
  ['ES0148396007', 1058],
  ['IT0005366767', 6921],
  ['NO0010365521', 48],
  ['NO0010708910', 48],
  ['GB0031274896', 361],
  ['IE00B9MRHC27', 1703],
  ['IT0003497168', 6921],
  ['NO0010863285', 48],
  ['FR0000120628', 25],
  ['ES0121975009', 1058],
  ['LU0256846139', 349],
  ['LU0562822386', 1330],
  ['JE00BDD9Q840', 6920],
  ['FR0004038263', 25],
  ['FR0000120503', 25],
  ['IT0001268561', 6921],
  ['CH1129677105', 4],
  ['CH0404880129', 4],
  ['FR0000120644', 25],
  ['FR0010131409', 6808],
  ['GB00B8C3BL03', 361],
  ['ES0157261019', 1058],
  ['DE0007203705', 44],
  ['GB00B5N0P849', 361],
  ['LU0229949994', 349],
  ['FR0000121147', 25],
  ['IE00BYYLVH00', 349],
  ['FR0011476928', 25],
  ['IE00BFTWP510', 1703],
  ['LU0292095535', 1703],
  ['CH0017142719', 4],
  ['NL0013654783', 38],
  ['LU0070992663', 349],
  ['LU1681046006', 25],
  ['CH0044328745', 65],
  ['NL0000360618', 38],
  ['LU0070214290', 17],
  ['JP3783600004', 106],
  ['LU0278466700', 15],
  ['LU1900066629', 2779],
  ['CH0001473559', 4],
  ['IE00BYZK4883', 1703],
  ['SG1T56930848', 120],
  ['LU1273489440', 349],
  ['LU0629460089', 1703],
  ['IE00B57X3V84', 1703],
  ['LU0152980495', 2779],
  ['GRS003003035', 34],
  ['FR0010340141', 25],
  ['DE0005773303', 44],
  ['DE000A194DD9', 16],
  ['XS1396261338', 16],
  ['FR0000051732', 25],
  ['DE000A11QSB8', 16],
  ['NL0012969182', 38],
  ['XS1880442717', 558],
  ['DE000A1C5D13', 2779],
  ['IE00B48X4842', 1703],
  ['IE00BMDH1538', 1703],
  ['IE00B0M63391', 719],
  ['GB00BP6MXD84', 38],
  ['GB00BLPJ1272', 699],
  ['GB00B17BBQ50', 100],
  ['SG2D00968206', 120],
  ['LU0390136736', 349],
  ['LU1135865084', 25],
  ['IE00B3CNHG25', 6920],
  ['FR0011871078', 25],
  ['AU000000CTD3', 111],
  ['CH0244767585', 4],
  ['CH0106405860', 351],
  ['IE00BGJWX091', 1703],
  ['IE00B42Z5J44', 6920],
  ['DE000A1EWWW0', 44],
  ['CH0014284498', 4],
  ['GB00B63QSB39', 361],
  ['JP3758200004', 106],
  ['IE00BYXVGY31', 719],
  ['LU0974299876', 65],
  ['FR0000052680', 25],
  ['AU000000MQG1', 111],
  ['AU000000BRG2', 111],
  ['AU000000NAB4', 111],
  ['AU000000JHG6', 111],
  ['AU000000LLC3', 111],
  ['XS1140860534', 653],
  ['AU000000LNK2', 111],
  ['CH0319416936', 4],
  ['LU1127514245', 361],
  ['BE0003470755', 6],
  ['LU1681037781', 719],
  ['IE00B4WXJD03', 361],
  ['NL00150001Q9', 6921],
  ['CH0238627142', 4],
  ['LU0875160326', 1703],
  ['CH0011108872', 4],
  ['PAL2400671A3', 65],
  ['NL0010583399', 38],
  ['IE0001827041', 361],
  ['JP3124400007', 106],
  ['DE0006070006', 44],
  ['IT0005239360', 6921],
  ['JP3277150003', 106],
  ['SG1T22929874', 120],
  ['FR0010417345', 25],
  ['FR0010251744', 1058],
  ['IE00BG04LZ52', 4],
  ['CH0024638196', 4],
  ['CH0011178255', 4],
  ['BE0003816338', 65],
  ['CH0126673539', 4],
  ['AU000000ARB5', 111],
  ['GG00BMXNVC81', 719],
  ['ES0178165017', 1058],
  ['DE0008490962', 1330],
  ['LU0659580079', 1703],
  ['IE00B4K6B022', 1703],
  ['ID1000061302', 146],
  ['CL0002009646', 84],
  ['LU0357130854', 16],
  ['DE0005190003', 44],
  ['CH0481488069', 880],
  ['CH0454664027', 349],
  ['IE0005711209', 67],
  ['LU0129412341', 1330],
  ['JE00B1VS3002', 6920],
  ['GB00B15KY211', 6920],
  ['IE00B7452L46', 361],
  ['LU0138821268', 1330],
  ['LU0093503810', 1330],
  ['LU1215461085', 6920],
  ['LU1048313891', 349],
  ['IE00B52VJ196', 1703],
  ['IE00BJZ2DD79', 1703],
  ['IE00BNH72088', 1703],
  ['FR0012616852', 25],
  ['FR0011981968', 25],
  ['LU0942970285', 349],
  ['LU1094612022', 1703],
  ['DE000ENAG999', 44],
  ['CH0008899764', 4],
  ['DE000A1ML7J1', 44],
  ['LU1834984798', 25],
  ['LU1834988278', 25],
  ['JE00BYVQYS01', 361],
  ['DK0060952240', 53],
  ['CH0025238863', 4],
  ['CH0239229302', 4],
  ['DE000A13SX22', 44],
  ['JE00BDD9Q840', 6920],
  ['ES0137650018', 1058],
  ['XS2212625656', 653],
  ['XS2202907510', 653],
  ['AN8068571086', 65],
  ['AT0000821103', 50],
  ['DK0010181759', 12],
  ['IE00BMW42306', 1703],
  ['CNE1000003G1', 104],
  ['CNE1000003X6', 104],
  ['CH0013841017', 4],
  ['GB00BGDT3G23', 361],
  ['LU1834988781', 6920],
  ['LU0480132876', 1703],
  ['LU1834988195', 25],
  ['LU1834988351', 6920],
  ['IE0004791160', 16],
  ['CH0100837282', 4],
  ['LU0308864023', 13],
  ['SE0000115446', 53],
  ['AU0000188021', 111],
  ['IE0003864109', 361],
  ['FR0000053225', 25],
  ['DE0005118806', 44],
  ['IE00B52SF786', 361],
  ['IE00BDFGJ627', 361],
  ['IE00BYXG2H39', 1703],
  ['GB0033986497', 361],
  ['IE00B1RR8406', 6902],
  ['IE0031442068', 719],
  ['MU0527S00004', 365],
  ['IE0000829238', 1330],
  ['FR0000184798', 25],
  ['IE00BKX55Q28', 361],
  ['LU1452600270', 361],
  ['IE00BF4NQ904', 6920],
  ['FR0013280286', 25],
  ['FR0000050809', 25],
  ['FR0014003TT8', 25],
  ['DE0005140008', 44],
  ['CH0111762537', 4],
  ['GB00BN7SWP63', 361],
  ['FI0009005987', 40],
  ['NL00150003E1', 38],
  ['FR0000035164', 25],
  ['BE0003851681', 6],
  ['NO0010571680', 48],
  ['FR0000077919', 25],
  ['SG1U76934819', 120],
  ['IE00BZ048462', 361],
  ['DK0060542181', 12],
  ['AU000000TLS2', 111],
  ['NL0010273215', 38],
  ['FR0011950732', 25],
  ['LU0119620416', 349],
  ['KR7005930003', 123],
  ['CH0011432447', 4],
  ['FR0013465424', 16],
  ['AT0000APOST4', 50],
  ['CH0047533523', 351],
  ['NL0000116168', 558],
  ['FR0000066482', 25],
  ['CH0047533549', 349],
  ['DE000A13R7Z7', 16],
  ['LU0292109856', 1703],
  ['LU0073232471', 13],
  ['GB00B033F229', 361],
  ['IE00B0M63060', 361],
  ['CH0358654975', 4],
  ['IT0005466195', 5493],
  ['CH0465044623', 4],
  ['FR0000121329', 25],
  ['LU0107852195', 349],
  ['IT0003007728', 6921],
  ['XS0114288789', 549],
  ['NL0000395903', 38],
  ['XS0209139244', 1330],
  ['IL0010851660', 67],
  ['DE0008232125', 44],
  ['GB00B63H8491', 361],
  ['IE00B3VWN393', 361],
  ['NL0012650469', 38],
  ['LU0346388969', 13],
  ['GB0006449366', 361],
  ['GB0000961622', 361],
  ['DE000KGX8881', 44],
  ['IE00B53L3W79', 1703],
  ['CH0002361068', 4],
  ['CH0010570767', 4],
  ['GB0004657408', 361],
  ['DK0010244508', 12],
  ['SE0012116390', 53],
  ['LU1681045370', 25],
  ['XS1506085114', 558],
  ['IE00BVXBH163', 361],
  ['IE00BQQ3Q067', 365],
  ['IE00BYXYYK40', 361],
  ['CLP321331116', 84],
  ['DE000PAH0038', 44],
  ['DE0008051004', 44],
  ['FR0011891258', 25],
  ['DE0001102416', 551],
  ['FR0010241638', 25],
  ['IE00B53HP851', 361],
  ['GB0004052071', 361],
  ['FR0010315770', 1703],
  ['GB0004478896', 361],
  ['FR0013214145', 25],
  ['GB0007908733', 361],
  ['LU1296758029', 2779],
  ['LI0315487269', 4],
  ['GB00B0LCW083', 361],
  ['IL0011301780', 67],
  ['JP3548660004', 106],
  ['CH0017875789', 4],
  ['XS2361258317', 6915],
  ['IE00B1FZS798', 719],
  ['IE00BYXPSP02', 361],
  ['IE00B1FZSC47', 719],
  ['AU000000COI3', 111],
  ['DE000A0TGJ55', 44],
  ['LU0061175625', 2779],
  ['CH0106027193', 349],
  ['DE0002635307', 1703],
  ['BE0974338700', 34],
  ['FR0013333432', 25],
  ['JP3266400005', 106],
  ['NL0012169213', 44],
  ['GB00B15KXV33', 6920],
  ['GB0006776081', 361],
  ['CH0024590272', 4],
  ['FR0000045072', 25],
  ['GB00BYWKBV38', 361],
  ['NL0011585146', 6921],
  ['GB0007099541', 361],
  ['IE00BFM6TC58', 361],
  ['LU1169830285', 349],
  ['LU0088087324', 25],
  ['GB0007188757', 361],
  ['LU0132412106', 1330],
  ['GG00B2R9PM06', 361],
  ['LU0387754996', 2779],
  ['DE0005557508', 44],
  ['IE00B2QWCY14', 1703],
  ['LU0274211217', 1703],
  ['SG1U68934629', 120],
  ['LU0274211480', 1703],
  ['LU1602144575', 25],
  ['LU1681041973', 25],
  ['DE0006916604', 44],
  ['CH0102659627', 4],
  ['FR0000062671', 25],
  ['BE0003739530', 6],
  ['JP3039100007', 106],
  ['LU0533033071', 349],
  ['IE0032895942', 361],
  ['AU000000REA9', 111],
  ['LU0208853274', 16],
  ['DE0001102341', 551],
  ['GB00B10RZP78', 361],
  ['AU000000RIO1', 111],
  ['AU000000NAN9', 111],
  ['AU000000NWL7', 111],
  ['SG0531000230', 120],
  ['AU000000S320', 111],
  ['ARBANS010010', 82],
  ['AU000000SEK6', 111],
  ['LU0169518387', 1330],
  ['GB0005405286', 104],
  ['GB0005405286', 104],
  ['LU0170475312', 16],
  ['IE00B441G979', 6920],
  ['LU0170475585', 2779],
  ['IE00BJJPVP04', 361],
  ['IE00BGPP6473', 1703],
  ['LU0292106167', 1703],
  ['IE00BFXYHY63', 1703],
  ['SE0018012494', 53],
  ['AU000000WOR2', 111],
  ['AU000000AZJ1', 111],
  ['AU000000ALQ6', 111],
  ['AU000000CBA7', 111],
  ['AU000000BXB1', 111],
  ['AU000000IPH9', 111],
  ['LU0109981661', 16],
  ['AU000000IRE2', 111],
  ['JP3914400001', 106],
  ['IE00BFZXGZ54', 6920],
  ['JP3670800006', 106],
  ['XS1568874983', 2779],
  ['AU000000CWY3', 111],
  ['GB0004726096', 361],
  ['XS2230275633', 558],
  ['IE00B9CQXS71', 1703],
  ['DE000CBK1001', 44],
  ['IE00BZ17CN18', 361],
  ['FR0010425595', 6808],
  ['NL0009434992', 65],
  ['FR0000127771', 25],
  ['IE00BCLWRG39', 361],
  ['CH0130293662', 4],
  ['GB00BJVQC708', 361],
  ['FR0007052782', 25],
  ['ES0175438003', 1058],
  ['LU1789205884', 38],
  ['LU0170994346', 2779],
  ['CH0012829898', 4],
  ['CH0210483332', 4],
  ['DE0005545503', 44],
  ['ES0130670112', 1058],
  ['DE0005785802', 44],
  ['FR0000054470', 25],
  ['DE0006599905', 44],
  ['FR0004125920', 25],
  ['BE0974320526', 6],
  ['NL0010773842', 38],
  ['FR0013153541', 25],
  ['ES0105630315', 1058],
  ['LU1681040900', 1703],
  ['LU0256839274', 351],
  ['IE00BF20LF40', 361],
  ['IE00B43HR379', 361],
  ['GB00BYT1L205', 361],
  ['LU0446734872', 1703],
  ['IE00BKM4GZ66', 719],
  ['IE00B14X4S71', 719],
  ['IE00BYXYYM63', 365],
  ['FR0004056851', 25],
  ['DE0007472060', 17],
  ['LU0053685029', 1330],
  ['ES0116870314', 1058],
  ['FR0014008VX5', 25],
  ['FR0000031775', 25],
  ['LU0390221256', 2779],
  ['FR0007054358', 25],
  ['IE00BQQP9F84', 361],
  ['SG1Q52922370', 120],
  ['FR0010688176', 25],
  ['XS0556373347', 558],
  ['IE00B1XNHC34', 1703],
  ['LI0106892909', 422],
  ['LI0017755534', 18],
  ['LI0183909790', 422],
  ['LI0108469029', 422],
  ['LU1560649987', 431],
  ['LU0346388530', 205],
  ['LI0183909998', 422],
  ['LU0507266491', 349],
  ['LI0015327906', 18],
  ['IE00BF451355', 3231],
  ['LU1477566407', 354],
  ['LU1852330908', 705],
  ['IE00B16C1H01', 2731],
  ['LU0329592538', 205],
  ['LU1517942469', 478],
  ['IE00B29M2H10', 2601],
  ['LU0890595423', 3231],
  ['LU0093504206', 17],
  ['LU0635705915', 2901],
  ['LU0929966207', 431],
  ['LU0568602667', 17],
  ['LU0627764474', 9760],
  ['IE00B4PRCS59', 3232],
  ['LU0979137147', 3313],
  ['LU0862043550', 9760],
  ['IE00BFCB7L57', 2731],
  ['LU0899940471', 4411],
  ['FR0010547869', 3230],
  ['IE0033640933', 17],
  ['FR0010371609', 3230],
  ['LU0859042482', 431],
  ['XS1939356645', 13],
  ['LU0125948108', 2779],
  ['LU0648314028', 3313],
  ['LU0217389567', 431],
  ['XS1958307461', 568],
  ['LU0192238508', 3231],
  ['IE00BF4NB955', 9760],
  ['LU0812919776', 3231],
  ['LU0258954014', 3313],
  ['IE00BV8WVB25', 3230],
  ['LU0704154458', 3231],
  ['LU0210528500', 3313],
  ['LU0088302236', 707],
  ['LU0214494824', 205],
  ['LU0210536198', 205],
  ['IE00B04TTW78', 2712],
  ['LU0657931563', 431],
  ['LU0012006317', 354],
  ['FR0012365013', 3230],
  ['IE00BHBFD812', 675],
  ['LU1790048364', 9760],
  ['LU1793346666', 3231],
  ['LU1793347128', 2605],
  ['IE00BYZB6Q30', 2605],
  ['LU0094488615', 354],
  ['LU1720112173', 3230],
  ['LU0428438575', 3313],
  ['LU0861897394', 3230],
  ['LU0042381250', 354],
  ['FR0011188259', 3230],
  ['LU0577855355', 9760],
  ['LU0905645874', 3313],
  ['LU1145152564', 3313],
  ['LU1255011501', 431],
  ['IE00B3MC6Z15', 3059],
  ['LU1958208214', 3313],
  ['LU1842710524', 3231],
  ['LU0152645866', 3231],
  ['LU0871572292', 205],
  ['AU60IOF01131', 3298],
  ['IE00B3T31Z22', 2668],
  ['LU0337786866', 3231],
  ['IE00BFZD2467', 2651],
  ['LU0415391514', 3230],
  ['LU1477743204', 3230],
  ['LU0702159939', 431],
  ['FR0010286005', 3230],
  ['FR0010027623', 3230],
  ['IE00B5716683', 3232],
  ['IE00B8JDQ960', 2608],
  ['IE00B410WP56', 9760],
  ['IE00B8Q8GH20', 613],
  ['LU0403290215', 431],
  ['IE00BCCW5L37', 3230],
  ['FR0007450002', 2732],
  ['IE00BFNWYS31', 9760],
  ['LU1751207694', 431],
  ['LU1910165643', 431],
  ['LU1325144027', 3520],
  ['LU1581426274', 478],
  ['LU1245923302', 354],
  ['LU0181998153', 2655],
  ['LU0323456466', 3313],
  ['LU0622664224', 430],
  ['IE00BK5X4F63', 2731],
  ['LU0345780950', 337],
  ['IE00BHWQNN83', 2732],
  ['LU0611602995', 705],
  ['LU0175073625', 9760],
  ['FR0000422859', 3230],
  ['LU0931237860', 2720],
  ['LU1090153773', 3231],
  ['LU0269905302', 431],
  ['LU1003376065', 431],
  ['LU0566484704', 431],
  ['LU0996453428', 3313],
  ['LU0947863048', 3231],
  ['LU0931238082', 2719],
  ['XS1550975079', 186],
  ['LU0050381036', 9760],
  ['IE000IIQEY56', 3313],
  ['LU2292492746', 3233],
  ['FR0010298596', 3230],
  ['LU0323243989', 9760],
  ['FR0010601898', 3230],
  ['IE00B41M1657', 9760],
  ['LU0423858678', 3313],
  ['LU0957039927', 431],
  ['LU0266009793', 1330],
  ['LU0423858918', 705],
  ['LU0491818331', 431],
  ['LU0903161841', 3230],
  ['IT0005421646', 669],
  ['XS1881594946', 19],
  ['LU1076333167', 430],
  ['LU0638558634', 9760],
  ['LU1160526791', 2901],
  ['LU0638558808', 9760],
  ['LU1075211869', 431],
  ['LU0903162229', 3231],
  ['LU0627762189', 9760],
  ['LU2145462722', 430],
  ['FR0011441849', 2731],
  ['LU0433182416', 2779],
  ['IE0032591004', 3059],
  ['IE00B23XCZ83', 3231],
  ['IE0002420739', 2608],
  ['LU0151262564', 354],
  ['FR0011408426', 3230],
  ['IE00BWCH4002', 2632],
  ['FR0010199075', 3230],
  ['LU1160357403', 3230],
  ['LU1053186349', 705],
  ['FR0013311289', 430],
  ['LU0893933373', 205],
  ['LI0323366331', 422],
  ['LU1883841535', 3231],
  ['LU0971614614', 349],
  ['LU1883849603', 2779],
  ['IE00BH7Y7L38', 3230],
  ['LU0895805017', 354],
  ['LU0627762262', 9760],
  ['LU0402208523', 9760],
  ['DE0001030906', 551],
  ['LU0448837160', 705],
  ['LU0428745664', 431],
  ['LU1013116519', 707],
  ['LU1050446076', 3520],
  ['LU0941349192', 2732],
  ['LU0390136223', 2655],
  ['LU0162829799', 17],
  ['LU1540961163', 9760],
  ['LU1540962211', 9760],
  ['LU0823399810', 2652],
  ['LU0713318490', 3552],
  ['LU1103207525', 3230],
  ['LU0252652382', 205],
  ['IE00B87MFH62', 9760],
  ['LU1750111707', 3520],
  ['LU1271706068', 3231],
  ['IE00BD8RFH57', 3313],
  ['LU0398248921', 430],
  ['LU0873628688', 431],
  ['IE00BC9S3W16', 675],
  ['IE00B531PK96', 3231],
  ['DE000BU0E022', 551],
  ['XS1859010685', 3185],
  ['LU0568583933', 354],
  ['LU1963359515', 2901],
  ['IE00B4KZ8V93', 2651],
  ['LU1725403254', 431],
  ['LU1376384100', 431],
  ['LU0822668108', 431],
  ['IE00BFPM9Y26', 9760],
  ['LU1720794822', 9760],
  ['LU0289472085', 354],
  ['LU0815276950', 431],
  ['LU0323456896', 431],
  ['LU0953040879', 9760],
  ['LU1106505156', 354],
  ['IE00B95L3899', 3313],
  ['LU2145463027', 430],
  ['XS1953057491', 186],
  ['IE0002460867', 2608],
  ['LU0950816578', 2901],
  ['LU1129992308', 354],
  ['LU0627764128', 9760],
  ['LU1295632571', 431],
  ['LU1433229124', 431],
  ['LU0133095157', 431],
  ['IE0030565943', 3231],
  ['LU1844121522', 3231],
  ['LU0451395577', 3230],
  ['LU1079060619', 3231],
  ['IE00BK6SB820', 2761],
  ['LU0979136255', 3313],
  ['IE00B56CKP98', 9760],
  ['IE00B4PTJ249', 205],
  ['IE0031559291', 2718],
  ['CH0555599015', 402],
  ['CH1114374361', 402],
  ['LU2278102541', 431],
  ['LU0888974473', 354],
  ['LU0926439729', 3520],
  ['LU1960672217', 707],
  ['IE00BDR0JY05', 3230],
  ['IE00BYZB6R47', 2605],
  ['LU0986736956', 431],
  ['LU1200235437', 9760],
  ['IE00BD008T51', 9760],
  ['LU1189806976', 9760],
  ['LU1116896017', 9760],
  ['LU1116894582', 9760],
  ['IE00BHBX1032', 2608],
  ['LU0227757233', 430],
  ['LU0575136915', 613],
  ['LU0035378891', 3231],
  ['LU0690086581', 478],
  ['LU0355496760', 430],
  ['LU1769944015', 431],
  ['LU0300834669', 9760],
  ['FR0012767093', 3231],
  ['LU1116894822', 9760],
  ['LU0219441069', 18],
  ['LU0231479717', 431],
  ['LU0258954444', 3313],
  ['LU1425341424', 9760],
  ['FR0010557967', 3230],
  ['FR0010653501', 2732],
  ['IE00B5WN3467', 2732],
  ['LU1225540076', 3231],
  ['LU0618382104', 3231],
  ['IE00B52QBB85', 2731],
  ['LU1670724704', 354],
  ['LU0337787088', 3231],
  ['FR0010213355', 3313],
  ['LU0514679900', 3313],
  ['LU0627762932', 9760],
  ['LU0510167009', 205],
  ['LU0972027022', 706],
  ['LU0278456651', 354],
  ['LU0439179432', 354],
  ['LU0266512127', 18],
  ['LU0219424131', 14],
  ['LU1340702692', 337],
  ['LU1017642064', 431],
  ['LU0827880344', 705],
  ['LU0400030887', 431],
  ['LU0400029954', 431],
  ['LU0269905641', 431],
  ['LU0842207952', 9760],
  ['LU0195953152', 2655],
  ['IE00B3MCK713', 2655],
  ['GB00B8848T44', 705],
  ['LU0937588209', 3313],
  ['LU0936248318', 430],
  ['LU0940717399', 3230],
  ['LU1442548993', 1330],
  ['LU0219440764', 18],
  ['CH0048799099', 9760],
  ['IE00BWWCQS74', 9760],
  ['CH0140909315', 9760],
  ['CH0140909224', 9760],
  ['IE00B000C709', 2655],
  ['LU0368249560', 431],
  ['LU0940717472', 3233],
  ['IE00BJVNGS06', 3231],
  ['LU0345776172', 3231],
  ['FR0014000U71', 3230],
  ['IE0034085260', 2608],
  ['LU1333146287', 9760],
  ['LU0607220646', 354],
  ['CH1159248751', 3341],
  ['FR0127921155', 527],
  ['LU0482270666', 430],
  ['LU1378878869', 354],
  ['LU1434519929', 2731],
  ['IE00BLZH2R37', 3231],
  ['LU1670723565', 431],
  ['LU0358423738', 9760],
  ['IE00B80G9288', 205],
  ['FR0000984254', 3231],
  ['IE00BYZNBH50', 3230],
  ['FR0014006JN5', 3230],
  ['IE0032590923', 3059],
  ['LU0295112097', 76],
  ['LU1041600427', 431],
  ['LU2332895668', 2901],
  ['LU0482910402', 354],
  ['LU1727361575', 431],
  ['LU0842207440', 9760],
  ['IE00B87KCF77', 205],
  ['LU1204193236', 705],
  ['IE00BF5MKL65', 2761],
  ['IE00B5VN1108', 686],
  ['LU2048742717', 9760],
  ['LU1030900838', 431],
  ['IE00B5BHGW80', 205],
  ['LU1046231582', 431],
  ['CH0190950219', 9760],
  ['LU1135520697', 354],
  ['XS2307764238', 186],
  ['LU0564079365', 3231],
  ['LU1236619232', 431],
  ['LU0983164699', 3231],
  ['LU1240770872', 354],
  ['XS2397065330', 3183],
  ['IE00BF5H4X12', 2608],
  ['IE00BF5DZ259', 3231],
  ['LU1717117896', 3520],
  ['LU1720796280', 9760],
  ['IE00BQ1YBP44', 2734],
  ['LU1720795639', 9760],
  ['DE000BU0E030', 551],
  ['LU0857590862', 431],
  ['LU0769026823', 3230],
  ['LU0564079282', 3313],
  ['LU0091117944', 3231],
  ['LU0569863326', 3231],
  ['CH0011292395', 431],
  ['XS1713475306', 186],
  ['LU1272300218', 3231],
  ['LU0704905446', 3313],
  ['LU0368231949', 354],
  ['LU0564079449', 3230],
  ['DE000A1G85D0', 186],
  ['LU0006277635', 9760],
  ['LU0219445482', 3231],
  ['LU0292585030', 9760],
  ['IE00BF451D56', 2608],
  ['LU0600008758', 354],
  ['LU0096363154', 3552],
  ['LU1396461771', 2640],
  ['LU1269171986', 354],
  ['IE00B43C0T93', 3231],
  ['IE00BFMHRK20', 3231],
  ['IE00BGSXT619', 9760],
  ['LU2001262547', 3313],
  ['LU0353189763', 2731],
  ['LU1345482589', 431],
  ['LU0128316840', 9760],
  ['IE0033989843', 2718],
  ['IE00BYW6V880', 2881],
  ['LU0866838575', 9760],
  ['GB00B4NXY349', 9760],
  ['LI0108468880', 422],
  ['LU0346390510', 431],
  ['XS1960248919', 3185],
  ['XS1088900615', 192],
  ['LU0816332745', 205],
  ['LU0976556695', 354],
  ['XS2153406868', 18],
  ['LU0823413587', 3319],
  ['IE00BHBX1D63', 675],
  ['LU0823389852', 337],
  ['LU1646897352', 354],
  ['LU0328507826', 431],
  ['LU0909491952', 9760],
  ['LU1079060882', 3230],
  ['LU0211327480', 2655],
  ['LU1670722161', 354],
  ['LU1670723482', 431],
  ['LU1442549538', 3231],
  ['LU1670722757', 354],
  ['LU1670722674', 354],
  ['LU1965932848', 3313],
  ['LU0225741247', 354],
  ['LU0098864514', 2655],
  ['XS1555080198', 872],
  ['LU0197216392', 13],
  ['LU0996778642', 3313],
  ['IE00BNCB6699', 2712],
  ['IE00BK0P2757', 3231],
  ['IE00B8FRY103', 9760],
  ['IE00B3K7XK29', 2608],
  ['IE00B8HX1V50', 3231],
  ['CH0307285194', 205],
  ['FR0010058008', 430],
  ['LU0327604228', 9760],
  ['IE00B84J9L26', 205],
  ['LU2093604622', 431],
  ['LU0982776840', 3230],
  ['FR0010460493', 3230],
  ['IE000ZC67B54', 2724],
  ['LU0426533492', 3313],
  ['LU0936575439', 431],
  ['LU1223211001', 3231],
  ['LU0425308086', 17],
  ['LU0617149793', 205],
  ['LU0904783114', 431],
  ['LU0441852299', 431],
  ['LU0690375182', 354],
  ['IE00B8K7V925', 205],
  ['LU1353951533', 9760],
  ['IE0002RB4DO3', 9760],
  ['LU0674860647', 3313],
  ['LU1797814685', 431],
  ['IE00BD3JRQ99', 2608],
  ['LU0600005812', 14],
  ['LU0627764557', 9760],
  ['LU0787971695', 9760],
  ['LU0346390940', 431],
  ['LU1573120497', 3232],
  ['XS1108847531', 186],
  ['LU0276015533', 9760],
  ['LU0620232016', 431],
  ['XS2345190263', 186],
  ['LU0106239873', 352],
  ['LU0114722738', 13],
  ['LU1752458551', 2761],
  ['LU1752456936', 2761],
  ['LU0129496690', 431],
  ['LU1515367867', 3230],
  ['CH0260709552', 2901],
  ['XS1819575066', 186],
  ['LU0106258741', 7371],
  ['LU1775951368', 431],
  ['IE00B65YMK29', 205],
  ['LU0956908742', 705],
  ['IE00B0V9T979', 2608],
  ['IE00BFMWWL31', 2608],
  ['CH0473589759', 402],
  ['LU0366533882', 354],
  ['IE00B29M2L55', 205],
  ['LU0841596629', 354],
  ['IE00BF2ZVB54', 205],
  ['FR0013518958', 3230],
  ['LU0244149497', 1115],
  ['CH0116771244', 431],
  ['FR0013245354', 2732],
  ['FR0013215407', 25],
  ['LU1340703666', 3231],
  ['LU0177497814', 354],
  ['LU0351545669', 354],
  ['IE0009515622', 3231],
  ['FR0127921171', 527],
  ['LU0210536867', 349],
  ['LU0153358154', 17],
  ['LU1509170699', 354],
  ['LU1206782309', 431],
  ['LU1255010958', 3313],
  ['LU1279333329', 431],
  ['LU0555019479', 3313],
  ['LU1121101866', 3313],
  ['LU1704635793', 3231],
  ['LU0952587862', 2731],
  ['IE00BD38JM62', 3231],
  ['IE00BYSRYZ31', 2601],
  ['IE00BYSRYY24', 2601],
  ['LU0134335420', 354],
  ['IE00B40ZVV08', 205],
  ['LU0557861274', 18],
  ['IE00BYZB6N09', 2605],
  ['LU0146923718', 18],
  ['LU1760778834', 431],
  ['LU0280430405', 431],
  ['LU1202667561', 2901],
  ['LU0947862743', 3230],
  ['LU0280807784', 431],
  ['LU0329430127', 205],
  ['LU0329593007', 205],
  ['LU0889566211', 2655],
  ['LU0724618946', 205],
  ['LI0214430972', 3313],
  ['IE00BKDRX971', 3059],
  ['IE00BYYLPW33', 2732],
  ['IE00B0HF2Z67', 613],
  ['LU0083912112', 431],
  ['LU0403290058', 431],
  ['LU0337786437', 337],
  ['DE000A169M74', 13],
  ['XS1303929894', 2779],
  ['LU2098088979', 2901],
  ['LU0564079522', 3313],
  ['LU0212993595', 9760],
  ['LU1727356906', 431],
  ['LU0382931417', 354],
  ['LU0353189680', 2731],
  ['IE00B6TYHG95', 9760],
  ['IE0009534508', 3231],
  ['LU1099987379', 3231],
  ['XS1789209365', 3243],
  ['LU0990544842', 430],
  ['XS1789209449', 3243],
  ['IE0031603545', 145],
  ['FR0011697028', 3183],
  ['XS1793250041', 203],
  ['LU2092461982', 9760],
  ['LU2138277665', 9760],
  ['IE00BZ036616', 2668],
  ['LU0765126635', 706],
  ['IE00BRJT7L67', 9760],
  ['IE0032578035', 2655],
  ['LU0975848697', 430],
  ['LU1135521232', 354],
  ['LU1135519921', 354],
  ['IE00BJ3VGK40', 9760],
  ['LU0996084801', 431],
  ['LU1135519335', 431],
  ['LU1236619406', 354],
  ['LU1421906139', 9760],
  ['LU1084746020', 431],
  ['LU0972074701', 431],
  ['LU0119620176', 354],
  ['DE0001030898', 551],
  ['LU0326808440', 9760],
  ['LU0482542841', 431],
  ['LU0654560100', 9760],
  ['LU0940716078', 1115],
  ['DE000A3G4H74', 3290],
  ['GB00BMVC4P19', 3313],
  ['IE0002460974', 2608],
  ['LU0569862351', 1115],
  ['FR0011261197', 2668],
  ['LU0504482588', 9760],
  ['LU0256064774', 205],
  ['IE00B3NLDF60', 2605],
  ['IE00BFMFDG40', 3232],
  ['LU0256065409', 613],
  ['IE00B59XD059', 205],
  ['LU1307754207', 3231],
  ['IE00B59SVZ19', 2608],
  ['XS1171593293', 186],
  ['IE00BRS5SP65', 3231],
  ['LU0107852435', 613],
  ['LU0239029407', 9760],
  ['LU0210528419', 3313],
  ['LU1303940784', 2668],
  ['IE00BYYLPZ63', 2731],
  ['LU0956908312', 431],
  ['FR0010949404', 2913],
  ['LU0265266980', 349],
  ['LU0940717126', 3230],
  ['LU1668154799', 3231],
  ['LU0862303640', 3231],
  ['LU0146925176', 3231],
  ['LU1576724287', 354],
  ['LU0219441499', 2779],
  ['IE00B193MN38', 2608],
  ['IE00B4R5BP74', 2718],
  ['LU0129488242', 431],
  ['LU0714639076', 3230],
  ['LU0683601610', 9760],
  ['LU0141250786', 4411],
  ['IE00BYT1GJ24', 2731],
  ['LU1006510769', 3313],
  ['LU0514679819', 431],
  ['IE00B520HN47', 2608],
  ['LU0122273880', 9760],
  ['LU0049014870', 2731],
  ['LU0405184523', 2761],
  ['LU0057025933', 16],
  ['IE00B11DWM09', 3234],
  ['LU0132668087', 3233],
  ['LU0128497707', 431],
  ['LU0244071956', 9760],
  ['LU0757359368', 13],
  ['LU0283739885', 1330],
  ['IE00B6VH4D24', 205],
  ['GB0002426533', 613],
  ['XS1560863802', 186],
  ['XS1234760699', 186],
  ['LU1269963572', 2877],
  ['LU0973524456', 354],
  ['GB0002426640', 613],
  ['LU0715768841', 2761],
  ['LU0231442988', 3231],
  ['LU1017786655', 3230],
  ['LU0306165886', 354],
  ['LU1814672827', 354],
  ['CH0428759747', 3313],
  ['IE00BD5HPH84', 205],
  ['IE00BFPM9H50', 9760],
  ['IE00BV1VS594', 2608],
  ['AU60ETL03794', 613],
  ['LU0345362361', 354],
  ['LU0854923066', 3231],
  ['LU0769027714', 3313],
  ['LU1047850349', 9760],
  ['LU1540961759', 9760],
  ['IE0009354923', 3231],
  ['FR0011034495', 3230],
  ['IE0030759645', 2608],
  ['XS1888180996', 13],
  ['CH0111013014', 354],
  ['LU1212749573', 431],
  ['IE0030760429', 2608],
  ['GB00BK5SP702', 3122],
  ['GB00BKYC2W77', 3122],
  ['LU0627762429', 9760],
  ['AU60CHN00050', 3298],
  ['IE0005300805', 2608],
  ['DE000DX0TXU7', 867],
  ['GB00B4Q5X527', 697],
  ['LU2597018998', 9760],
  ['XS2485805696', 2943],
  ['LU0102830865', 17],
  ['IE00BYXW4428', 3313],
  ['IE00BYXW4535', 3313],
  ['LU1084745998', 431],
  ['LU0132661827', 2794],
  ['LU1509170343', 354],
  ['LU0402208283', 9760],
  ['IE00B1WL3F32', 145],
  ['LU0931248719', 3231],
  ['LU0600008089', 431],
  ['LU0360482987', 354],
  ['CH0021732778', 431],
  ['LU0441851309', 205],
  ['LU0994379526', 3231],
  ['FR0010584474', 3230],
  ['LU0963986970', 9760],
  ['LU2305834124', 354],
  ['FR0011038785', 3230],
  ['LU0800573429', 430],
  ['IE00B3DKH950', 9760],
  ['LU0582533245', 430],
  ['LU0278531701', 354],
  ['GB0031775819', 361],
  ['LU1369533465', 9760],
  ['LU1369531766', 9760],
  ['LU0107157686', 2794],
  ['LU0860350494', 431],
  ['IE00BDD2F427', 3230],
  ['LU0854923223', 2720],
  ['LU1369535247', 9760],
  ['IE00B0V9T193', 3232],
  ['LU2264865770', 707],
  ['IE00B0V9T086', 2718],
  ['IE00BFRSV866', 205],
  ['LU0523283140', 9760],
  ['LU0278469043', 431],
  ['LU0152640982', 3231],
  ['LU0154237225', 13],
  ['LU1460793182', 3231],
  ['LU1190404852', 2731],
  ['FR0012770162', 3230],
  ['LU0853555976', 431],
  ['LU1280365633', 3230],
  ['LU0510758203', 706],
  ['LU0234573771', 205],
  ['IE00B3LMJF32', 3231],
  ['LU1048654534', 431],
  ['LU0333595519', 2761],
  ['LU1509170269', 431],
  ['IE00BFFK9L34', 2601],
  ['CH1122749711', 881],
  ['ES0141116030', 3230],
  ['LU0951559797', 430],
  ['IE00BFZN8B54', 3231],
  ['LU0159042083', 3313],
  ['XS1521039054', 13],
  ['LU0507266228', 354],
  ['LU0122274425', 9760],
  ['LU1120565483', 431],
  ['LU0219424487', 3230],
  ['LU1330191898', 9760],
  ['XS1297557412', 186],
  ['LU0141249770', 4411],
  ['LU1622399530', 192],
  ['LU0160363585', 431],
  ['XS1850725331', 463],
  ['LU1080015420', 3231],
  ['LU0280437673', 2779],
  ['LU0430226950', 9760],
  ['IE00B529XP53', 3231],
  ['LU0848413588', 431],
  ['LU0214705203', 354],
  ['LU0366536711', 354],
  ['LU0641746143', 430],
  ['LU2443760025', 3230],
  ['LU2443760298', 3233],
  ['LU0155953705', 17],
  ['LU0274905818', 3231],
  ['LU0406496546', 205],
  ['IE00B4W0NH34', 3232],
  ['IE00BZ4T6Q54', 2718],
  ['LU2479960879', 9760],
  ['IE00BWCGWH04', 9760],
  ['LU2479966132', 9760],
  ['IE00B5VJPM77', 205],
  ['LU0780248877', 354],
  ['LU0151262481', 354],
  ['IE00BTC0JS19', 9760],
  ['LU2479963543', 9760],
  ['LU0569863243', 3231],
  ['LU2479965597', 9760],
  ['LU0329631377', 205],
  ['IE00B563Q870', 9760],
  ['LU1369529786', 9760],
  ['LU0860715688', 430],
  ['LU0593848723', 205],
  ['IE00BYXX2V85', 3231],
  ['IE00BKZGJL69', 3231],
  ['LU0943508167', 1115],
  ['LU0800597873', 9760],
  ['LU0790204860', 3313],
  ['LU0273164177', 17],
  ['LU0300737201', 2655],
  ['GB00BD6SX109', 361],
  ['LU0611395327', 3231],
  ['IE00BKZGL873', 3231],
  ['IE00B8FGBZ03', 2605],
  ['FR0013518974', 3230],
  ['LU0570480771', 3233],
  ['IE00BN6JX572', 3313],
  ['LU0068578508', 13],
  ['LU1272300481', 3230],
  ['LU0769028019', 3313],
  ['LU0712124089', 431],
  ['LU0842207523', 9760],
  ['LU0773641450', 354],
  ['LU1657048275', 354],
  ['LU1292897086', 354],
  ['LU1913291719', 3313],
  ['LU0064321663', 708],
  ['IE00B597QY25', 3232],
  ['GB00B2PLJJ36', 2733],
  ['LU0122276552', 9760],
  ['LU0997718878', 2655],
  ['LU1481723747', 4411],
  ['XS1590067432', 186],
  ['IE00B99K4563', 3231],
  ['CH1159246946', 3341],
  ['LU1218206255', 431],
  ['LU0249549436', 9760],
  ['LU2049550184', 686],
  ['LU2194269929', 2901],
  ['LU0964942030', 430],
  ['LU0842207879', 9760],
  ['LU1090153856', 3231],
  ['LU0784394321', 3231],
  ['LU0969575645', 205],
  ['LU0231611681', 9760],
  ['BE0947764743', 9760],
  ['LU1499723234', 9760],
  ['LU0629158030', 205],
  ['IE00B6VHBN16', 2718],
  ['IE00B6VHBS60', 3232],
  ['IE00BD8RGM75', 3313],
  ['IE00BLLXGV72', 3231],
  ['FR0010149120', 7371],
  ['LU0234572450', 431],
  ['LU0984439082', 613],
  ['LU0326960662', 431],
  ['LU0095030564', 205],
  ['LU1560664358', 9760],
  ['LU1434519689', 2731],
  ['LU1130246405', 9760],
  ['LU1554442407', 478],
  ['IE00B734TY42', 2883],
  ['LU1291101126', 3230],
  ['IE00BF4RFT52', 2652],
  ['LU1480984928', 478],
  ['IE00BK5X4J02', 2734],
  ['FR0000009987', 3230],
  ['LU1839390173', 3313],
  ['IE00B11DWS60', 3234],
  ['LU1692112649', 2901],
  ['LU0999481087', 2608],
  ['LU2445852721', 2901],
  ['LU1554426111', 354],
  ['LU0950593094', 2761],
  ['LU0370946096', 3230],
  ['LU0984439249', 3230],
  ['CH0239657494', 132],
  ['IE00BK017B22', 2652],
  ['LU1664645287', 2652],
  ['LU0187024954', 431],
  ['LU0260641393', 3231],
  ['IE00B3N32X37', 3231],
  ['IE00B4VZPG27', 613],
  ['LU0219454989', 3231],
  ['IE00B61H9W66', 3231],
  ['FR0011006188', 3230],
  ['LU0156897901', 9760],
  ['LU0909494543', 354],
  ['LU0323456540', 705],
  ['LU1273507282', 431],
  ['LU0284396016', 430],
  ['IE00B8240T43', 3232],
  ['FR0010917658', 3230],
  ['IE00B11XYV36', 3230],
  ['LU0157308031', 205],
  ['FR0013507878', 3185],
  ['XS1693818285', 568],
  ['LU0170477797', 7371],
  ['XS2147977636', 17],
  ['CH0413237626', 3917],
  ['CH0439289163', 3917],
  ['LU1111643042', 2732],
  ['LU0978624194', 431],
  ['IE00B7LZ3N65', 2881],
  ['LU0226954369', 430],
  ['IE00BDHSR514', 1094],
  ['XS1151974877', 186],
  ['LU0490769915', 3230],
  ['LU0160155395', 2731],
  ['FR0010544791', 3230],
  ['LU0600007784', 705],
  ['XS1369278764', 16],
  ['XS0951216166', 6829],
  ['XS2102948994', 186],
  ['XS1384281090', 186],
  ['LU0526926950', 431],
  ['IE00BCBHYM33', 3231],
  ['LU0994381340', 3313],
  ['IE00BYQP5B29', 675],
  ['LU0195951966', 2655],
  ['IE00B967XG46', 2608],
  ['LU0612817204', 2731],
  ['IE00BF8H6P48', 3231],
  ['IE00B3KYRN47', 3231],
  ['FR0010321828', 205],
  ['LU0844697770', 9760],
  ['LU0441853008', 354],
  ['LU0128499158', 706],
  ['LU0368231436', 354],
  ['IE00B7483W12', 2632],
  ['LU0844696459', 9760],
  ['LU1064860692', 9760],
  ['LU1914600496', 3231],
  ['LU1914599623', 3231],
  ['LU0372198514', 2870],
  ['LU0864888259', 3231],
  ['LU0100597557', 431],
  ['LU0308864965', 3313],
  ['LU0870266391', 337],
  ['XS2589907653', 186],
  ['LU1914599110', 337],
  ['IE00BYZ0B320', 3231],
  ['LU0867954777', 431],
  ['LU0474363545', 430],
  ['LU0867954264', 3313],
  ['LU1442549371', 3231],
  ['LU1408526512', 430],
  ['LU1511578152', 478],
  ['LU0877285527', 430],
  ['LU0247234700', 2761],
  ['LU2022006568', 2901],
  ['IE00B1D7Z989', 613],
  ['LU0207025593', 9760],
  ['LU0209860427', 430],
  ['IE00B2QZMS41', 2608],
  ['LU0571085686', 3520],
  ['LU1554442662', 478],
  ['LU0946667085', 706],
  ['LU0278093082', 205],
  ['FR0013073731', 3230],
  ['IE00BYXVTY44', 3231],
  ['IE00B61N1B75', 3231],
  ['ZAE000015889', 365],
  ['IE00B2R34Y72', 2718],
  ['IE00BC7GWF39', 2605],
  ['IE00B3RW8498', 2731],
  ['LU1279334053', 354],
  ['FR0012847150', 3230],
  ['LU0476945828', 2655],
  ['LU1683288424', 2901],
  ['IE00B016J437', 3231],
  ['ES0183793001', 3230],
  ['IE00B4YLF345', 3233],
  ['IE00B0XJBQ64', 3230],
  ['LU1679117140', 9760],
  ['IE00B4L78B47', 205],
  ['LU0360484686', 354],
  ['LU0478345209', 2655],
  ['LU0219445649', 3231],
  ['LU0557290854', 431],
  ['IE00BL0BM478', 3313],
  ['CH0011292304', 706],
  ['IE0032314100', 3231],
  ['LU0211326755', 17],
  ['LU0878815397', 3313],
  ['LU0149084633', 354],
  ['LU0152644976', 3231],
  ['XS1555815494', 186],
  ['IE00B1D7YM41', 2608],
  ['XS1664647499', 569],
  ['LU0539802446', 9760],
  ['IE00B7KFL990', 205],
  ['LU1838927629', 354],
  ['LU1366712351', 430],
  ['LU1155982793', 3230],
  ['LU0607515367', 205],
  ['IE00B3W9BG81', 3230],
  ['IE00BYXW3V29', 2732],
  ['IE00BD3QFN30', 3231],
  ['IE00B0C18065', 2608],
  ['LU0845339554', 431],
  ['LU0855165741', 3231],
  ['LU0674140123', 430],
  ['ES0105413001', 5386],
  ['IE00BL5H0Z73', 3313],
  ['IE00B81TMV64', 2652],
  ['LU0867954421', 431],
  ['IE00BN71XW92', 9760],
  ['LU1324051827', 3231],
  ['IE00BJMXV950', 3231],
  ['LU0290355394', 3230],
  ['IE00BDZRXT69', 3231],
  ['LU0231204701', 2655],
  ['IE00BRS5SQ72', 3231],
  ['LU0283566767', 3230],
  ['CH0338509083', 2651],
  ['LU0870264776', 3231],
  ['LU0498181733', 354],
  ['LU0079475934', 9760],
  ['LU0978624350', 431],
  ['IE00B85KB857', 2605],
  ['LU0332315802', 354],
  ['LU0266009959', 9760],
  ['FR0010286013', 3230],
  ['LU0828908078', 2901],
  ['IE0034234553', 3231],
  ['IE00BYY02C96', 475],
  ['LU0278463947', 705],
  ['CH0036942727', 880],
  ['IE00B8DDPY03', 2761],
  ['LU0914733646', 3230],
  ['LU0238689110', 1330],
  ['LU0600008329', 431],
  ['IE00BD0Q8V55', 3059],
  ['IE00B986J944', 3231],
  ['XS1365787230', 656],
  ['FR0010607945', 3313],
  ['FR0010032326', 3230],
  ['IE00BZ60K206', 2605],
  ['LU0984217934', 3230],
  ['LU1376832967', 3231],
  ['IE00B5648R31', 9760],
  ['LU0370790650', 431],
  ['LU0206733890', 9760],
  ['LU1869582681', 431],
  ['LU1869582848', 354],
  ['LU1550213497', 431],
  ['IE00BQ3D6V05', 2731],
  ['IE00BD065N65', 2712],
  ['IE00BZ6SF527', 3230],
  ['LU0190161025', 1330],
  ['LU0861897477', 3230],
  ['XS1028952403', 186],
  ['LU0658026512', 3230],
  ['LU0408846458', 18],
  ['LU0712123867', 354],
  ['FR0007371729', 3230],
  ['LU1515367602', 3231],
  ['FR0010909531', 3319],
  ['LU0912262788', 2779],
  ['IE00BTJRKG04', 9760],
  ['IE00BYT42604', 686],
  ['LU0990494998', 478],
  ['LU0408846615', 431],
  ['IE00B3NS4D25', 205],
  ['IE00B6127M75', 2632],
  ['LU0600009053', 354],
  ['LU0378611387', 431],
  ['FR0011401728', 16],
  ['LU2146191999', 430],
  ['LU1728553774', 431],
  ['LU2613216295', 2731],
  ['IE0033758917', 205],
  ['IE00BYQDNF69', 3231],
  ['XS1422866456', 13],
  ['CH0547935129', 402],
  ['LU0289523259', 2605],
  ['LU0625451603', 15],
  ['IE00B837NY85', 3231],
  ['IE00B040MS79', 3200],
  ['IE00B0418046', 3231],
  ['LU0261950470', 431],
  ['IE00BYZ09Q19', 3231],
  ['LU1695535051', 3520],
  ['IE00BPYP3T56', 686],
  ['FR0013304441', 3230],
  ['LU0029761532', 2794],
  ['LU0735966888', 3313],
  ['LU0946222477', 431],
  ['LU0635705832', 2901],
  ['IE00B067MS69', 3059],
  ['LU0853555380', 205],
  ['XS0651001181', 192],
  ['IE000MJ9UJT3', 3313],
  ['LU0712206050', 705],
  ['IE00BH3WKX42', 2608],
  ['GB00BRGBL804', 1573],
  ['IE00B12VW565', 3231],
  ['FR0013294303', 430],
  ['LU0769026740', 3230],
  ['LU2085857899', 3230],
  ['LU0255798018', 16],
  ['IE00B411W698', 2601],
  ['LI0183908107', 422],
  ['IE00BFNWY275', 9760],
  ['IE00BMTRWY37', 3231],
  ['LU0769027474', 3230],
  ['LU0441851648', 431],
  ['LU0827879841', 354],
  ['LU0106234999', 13],
  ['XS1346228577', 203],
  ['LU0236177068', 705],
  ['LU1694800795', 9760],
  ['LU0397594465', 9760],
  ['XS1121503822', 2860],
  ['CH1122298826', 402],
  ['LU0569862609', 2794],
  ['LU1161526816', 3230],
  ['DE000BU0E006', 551],
  ['LU0853555463', 205],
  ['LU0542658678', 9760],
  ['IE00B00LSD17', 205],
  ['IE0032876397', 2718],
  ['LU0866417040', 478],
  ['LU1540961916', 9760],
  ['IT0001137345', 1573],
  ['XS0835891838', 203],
  ['LU1111703473', 2761],
  ['LU0426422076', 3231],
  ['LU0762807625', 205],
  ['LU0951484178', 430],
  ['IE00B60B5764', 3233],
  ['LU0982389560', 3231],
  ['LU0292585626', 18],
  ['LU1807329690', 477],
  ['CH0575811556', 1192],
  ['IE00B6Y7ZF85', 3231],
  ['LU0870268686', 3231],
  ['LU1052149017', 3313],
  ['LU0721536182', 431],
  ['LU0762813862', 431],
  ['LU0740858229', 3313],
  ['LU1084746376', 354],
  ['LU1340547436', 3230],
  ['IE00B073NJ12', 2718],
  ['LU1068204145', 3313],
  ['IE0033759436', 205],
  ['CH0342181622', 1174],
  ['FR0011269067', 2856],
  ['IE00BLR74S61', 3313],
  ['LU0694238923', 354],
  ['IE00B550HH55', 2718],
  ['FR0000288946', 9760],
  ['FR0000299620', 354],
  ['LU1670725776', 431],
  ['IE0002141913', 3231],
  ['LU1649332886', 205],
  ['LU0221833030', 431],
  ['LU0491817952', 1330],
  ['XS1743727130', 3699],
  ['IE00B98FL735', 3231],
  ['LU0128469243', 9760],
  ['LU0842208091', 9760],
  ['XS2035458350', 186],
  ['LU2092758999', 430],
  ['LU0476944342', 2655],
  ['XS2033327854', 203],
  ['LU0241881910', 9760],
  ['LU0227145629', 430],
  ['LU0975280552', 354],
  ['LU0637316331', 431],
  ['LU1165135952', 2652],
  ['LU2092759021', 430],
  ['LU2092759450', 430],
  ['LU0593848301', 205],
  ['LU0514680239', 431],
  ['FR0013519022', 3230],
  ['LU0234573854', 431],
  ['LU1660423721', 9760],
  ['LU2005507657', 2652],
  ['LU1694214633', 354],
  ['LU0539144625', 354],
  ['LU0505663400', 354],
  ['IE0002458671', 2605],
  ['LU0219491759', 3231],
  ['LU1080015693', 3230],
  ['LU0712123271', 354],
  ['IE0002459976', 2608],
  ['LU0769919795', 431],
  ['LU0390858792', 431],
  ['LU0737136415', 431],
  ['IE00B53XYJ72', 2608],
  ['LU0244615992', 3231],
  ['LU0618388994', 3233],
  ['LU1225540233', 3233],
  ['IE00BJXT4265', 3231],
  ['IE00BDZ7TF44', 2601],
  ['LU1586275825', 2655],
  ['LU0895805793', 431],
  ['XS1978209002', 13],
  ['XS1978210273', 50],
  ['LU1202666753', 2901],
  ['LU0888106944', 430],
  ['LU2114516292', 431],
  ['LU2549520950', 3313],
  ['IE00B56STR24', 3231],
  ['LU0742736886', 3313],
  ['LU0319686829', 3231],
  ['LU0408847183', 431],
  ['IE0032568770', 2718],
  ['LU0943509728', 3231],
  ['LU0089444409', 3230],
  ['LU0195948822', 2655],
  ['LU0241884856', 9760],
  ['LU0599213476', 3313],
  ['LU0512127548', 205],
  ['LU1181254019', 431],
  ['LU1076879987', 431],
  ['LU0940717639', 3231],
  ['LU0188501257', 2779],
  ['IE0033009238', 13],
  ['IE00B3NLTK32', 2605],
  ['LU0252968341', 205],
  ['LU1084486106', 706],
  ['IE00B12V2V27', 2608],
  ['LU1599187009', 9760],
  ['IE00BZCTK875', 2614],
  ['IE00BZCTKC13', 2614],
  ['LU1279333592', 431],
  ['IE00B11XZ871', 3231],
  ['IE00BFPM9Q42', 9760],
  ['LU1777194124', 431],
  ['IE00BYYLPD44', 2731],
  ['LU0458985636', 2901],
  ['LU0210533500', 205],
  ['LU0089440837', 9760],
  ['LU0210529144', 18],
  ['LU0192583275', 431],
  ['AU60DFA01081', 3298],
  ['IE00BKKJBP83', 9760],
  ['AU60ETL00196', 8506],
  ['IE00BDTMQ217', 205],
  ['LU0508301107', 9760],
  ['LU0066649970', 1330],
  ['IE00B3FNF987', 2608],
  ['LU1884795532', 2731],
  ['LU0430493568', 354],
  ['IE00BDT57R20', 2608],
  ['LU1001014080', 3231],
  ['IE00B4Y6GV43', 3233],
  ['XS2447764189', 186],
  ['MT7000008736', 245],
  ['XS2490325730', 501],
  ['XS2059791405', 1388],
  ['MT0000570102', 254],
  ['XD0144040140', 254],
  ['XS1173293561', 186],
  ['FR0000052516', 21],
  ['MU0502S00015', 254],
  ['CH1181262952', 246],
  ['XD0251344392', 254],
  ['IT0005456808', 254],
  ['CH0517585946', 246],
  ['CH1100420640', 246],
  ['XS2337254390', 3174],
  ['XS2242791080', 254],
  ['GB0009628438', 669],
  ['GG00B284YJ47', 642],
  ['CH0590417934', 246],
  ['XS1502188375', 1365],
  ['XD0277372351', 254],
  ['MT7000020624', 254],
  ['AU60DFA00422', 254],
  ['CH1114179026', 501],
  ['GB00BQS92151', 254],
  ['LU2443757583', 254],
  ['LU2443758987', 254],
  ['LU2443759019', 254],
  ['XD1105424711', 254],
  ['AU000000NMI4', 254],
  ['AU60DFA00414', 254],
  ['FR0010879056', 6184],
  ['MT7000020640', 254],
  ['IE00B7FN3K33', 3910],
  ['XS2416415383', 3174],
  ['MT7000020657', 254],
  ['MT7000020616', 254],
  ['IE00BJBZKF13', 2605],
  ['US16119P1084', 67],
  ['US698299AT16', 16],
  ['CA8119161054', 65],
  ['US8825081040', 67],
  ['US3741631036', 67],
  ['US8835561023', 65],
  ['US4642886877', 67],
  ['US40049JAZ03', 558],
  ['US0396971071', 67],
  ['US4642888105', 69],
  ['US21871N1019', 65],
  ['CA53680Q2071', 6184],
  ['US12503M1080', 896],
  ['US1730802014', 65],
  ['US4642875490', 69],
  ['US8888941023', 76],
  ['KYG4812S1012', 104],
  ['USG6711KAD75', 7372],
  ['US1104481072', 65],
  ['US10922N1037', 67],
  ['US12591DAC56', 104],
  ['US4642872919', 69],
  ['US822582BX94', 558],
  ['US05348EBF51', 558],
  ['US7711951043', 365],
  ['US742718EP07', 558],
  ['US89152UAH59', 558],
  ['US26444HAE18', 558],
  ['US91324PDP45', 558],
  ['US911312BM79', 558],
  ['US451102BT32', 1330],
  ['US6200763075', 65],
  ['BMG2519Y1084', 65],
  ['US06739H2067', 365],
  ['US29082A1079', 65],
  ['CA4495861060', 61],
  ['US05961W1053', 65],
  ['US459058JU87', 186],
  ['USU37818AX65', 558],
  ['US4581X0DY17', 186],
  ['US30231GBN16', 558],
  ['US438516BZ80', 558],
  ['US459058KN26', 186],
  ['US37954Y7803', 67],
  ['USP3R26HAA81', 558],
  ['CA7751092007', 61],
  ['US9344231041', 67],
  ['US1055321053', 65],
  ['US37954Y4677', 67],
  ['US42809HAG20', 558],
  ['US33734X1928', 67],
  ['US7960508882', 507],
  ['US06738E2046', 65],
  ['US29244A1025', 65],
  ['US4062161017', 65],
  ['US4642877397', 69],
  ['US78463X7729', 69],
  ['US29786A1060', 67],
  ['US92343V1044', 65],
  ['US78462F1030', 69],
  ['KYG4364R1056', 9760],
  ['CA2927661025', 61],
  ['US1717793095', 65],
  ['US91087BAE02', 3182],
  ['US22943FAH38', 558],
  ['US67011P1003', 65],
  ['US5260571048', 65],
  ['US56585A1025', 65],
  ['US97717W4226', 69],
  ['USL6388GAB60', 558],
  ['USG3925DAD24', 558],
  ['US5950171042', 67],
  ['US7547301090', 65],
  ['US00766Y2735', 76],
  ['CA0585861085', 61],
  ['US00827B1061', 67],
  ['US1850631045', 67],
  ['US92189F4037', 18],
  ['US9220428745', 69],
  ['US4655621062', 318],
  ['US0138721065', 65],
  ['US78463X3017', 69],
  ['US9220428588', 69],
  ['USY2R27RAB56', 558],
  ['US21036P1084', 65],
  ['US279158AK55', 558],
  ['US74767V1098', 65],
  ['US5178341070', 65],
  ['US4663131039', 65],
  ['US4642891802', 67],
  ['US46435G3341', 69],
  ['US46429B6719', 535],
  ['US4330001060', 65],
  ['US7437131094', 65],
  ['US5184391044', 65],
  ['USY3815NAZ43', 558],
  ['USG8450LAJ38', 3782],
  ['US0536041041', 67],
  ['CA13321L1085', 61],
  ['USH3698DCR38', 558],
  ['US74347B7148', 69],
  ['USP989MJAY76', 558],
  ['CA46428D1087', 61],
  ['US7561581015', 66],
  ['CA1360691010', 61],
  ['US06739H7439', 365],
  ['US78463X1524', 69],
  ['CA85207H1047', 69],
  ['US87918A1051', 65],
  ['US5011732071', 365],
  ['US5608773009', 365],
  ['US31154R1095', 65],
  ['US87184P1093', 365],
  ['US6293341037', 365],
  ['US6863311097', 365],
  ['US03524A1088', 318],
  ['CA1363851017', 61],
  ['US21077C3051', 67],
  ['US8064071025', 67],
  ['US59156RBH03', 558],
  ['US458140BD13', 558],
  ['US89153VAG41', 558],
  ['US6951561090', 65],
  ['US02319V1035', 318],
  ['US91913Y1001', 65],
  ['CA4969024047', 61],
  ['CA4509131088', 61],
  ['US30231G1022', 65],
  ['US03522AAG58', 558],
  ['US084670BS67', 558],
  ['US25470DAD12', 558],
  ['US026874DH71', 558],
  ['US94974BGH78', 558],
  ['US53656F4173', 69],
  ['US57164Y1073', 65],
  ['US92204A6038', 69],
  ['US92189F1140', 67],
  ['US9100471096', 67],
  ['US88032Q1094', 365],
  ['US25179M1036', 65],
  ['BMG540501027', 65],
  ['US92204A2078', 69],
  ['US64129H1041', 69],
  ['US46429B5984', 69],
  ['US0321086078', 69],
  ['US9220428661', 69],
  ['CA00829Q1019', 53],
  ['US98105HAC43', 558],
  ['US6976602077', 65],
  ['USP91528AA03', 590],
  ['US594918BY93', 558],
  ['US37954Y4420', 67],
  ['US38141GXM13', 558],
  ['US00287YBV02', 558],
  ['US64132B1026', 365],
  ['US0311621009', 67],
  ['US4642867497', 69],
  ['US4642886612', 67],
  ['US46431W8534', 67],
  ['US7433151039', 65],
  ['US64110L1061', 67],
  ['US88160R1014', 67],
  ['US9884981013', 65],
  ['US902613AX64', 558],
  ['US7785291078', 365],
  ['US2791581091', 65],
  ['US0378331005', 67],
  ['US0382221051', 67],
  ['US4581401001', 67],
  ['KYG6683N1034', 65],
  ['US0394831020', 65],
  ['US25152RXA66', 558],
  ['US4592001014', 65],
  ['US68622V1061', 65],
  ['KYG9361H1092', 361],
  ['US02376R1023', 67],
  ['US15961R1059', 65],
  ['US4601461035', 65],
  ['US78464A8624', 69],
  ['US74347G4165', 69],
  ['US24906P1093', 67],
  ['US25278X1090', 67],
  ['US47233W1099', 65],
  ['US8336351056', 65],
  ['US36266G1076', 67],
  ['US72201W7902', 76],
  ['US78464A5406', 69],
  ['US3015057074', 69],
  ['US46434G7640', 67],
  ['US9129091081', 65],
  ['US74347W3530', 69],
  ['US64110LAN64', 558],
  ['US50077LAB27', 558],
  ['US46434G8226', 69],
  ['US6951271005', 67],
  ['US46434G8143', 69],
  ['US69343P1057', 80],
  ['US0758871091', 65],
  ['US9311421039', 65],
  ['US4781601046', 65],
  ['US33733E8075', 69],
  ['US5007676787', 69],
  ['US2546871060', 65],
  ['US4642871689', 67],
  ['US2298991090', 65],
  ['US27579R1041', 67],
  ['US6267171022', 65],
  ['US03662Q1058', 67],
  ['US05561Q2012', 67],
  ['US03076C1062', 65],
  ['US6515871076', 65],
  ['US7043261079', 67],
  ['US3119001044', 67],
  ['US4180561072', 67],
  ['US4878361082', 65],
  ['US50077B2079', 67],
  ['CA45780E1007', 61],
  ['US81369Y3080', 69],
  ['US81369Y2090', 69],
  ['US31572Q8087', 67],
  ['US81369Y4070', 69],
  ['US4642885135', 69],
  ['US81369Y5069', 69],
  ['US8672ENAL69', 558],
  ['US58155Q1031', 65],
  ['US19046P2092', 67],
  ['US81369Y6059', 69],
  ['US86745K1043', 318],
  ['CA85210A1049', 61],
  ['US81369Y8030', 69],
  ['KYG4672N1198', 104],
  ['US03485P3001', 365],
  ['US74365P1084', 365],
  ['US46434V6478', 69],
  ['US81369Y7040', 69],
  ['US1696561059', 65],
  ['US43289P1066', 67],
  ['US03512TAB70', 558],
  ['US81369Y8865', 69],
  ['US42824CAY57', 558],
  ['US8760301072', 65],
  ['US92826C8394', 65],
  ['US4642871762', 69],
  ['US3773221029', 65],
  ['US29350E1047', 67],
  ['US6200711009', 67],
  ['US88023U1016', 65],
  ['US7010941042', 65],
  ['US8666741041', 65],
  ['US6361801011', 65],
  ['US2283681060', 65],
  ['US6882392011', 65],
  ['US5260573028', 65],
  ['US7443201022', 65],
  ['US5732841060', 65],
  ['US5745991068', 65],
  ['US29472R1086', 65],
  ['US98978V1035', 65],
  ['US95000U2D40', 558],
  ['US713448DY13', 558],
  ['US670346AP04', 558],
  ['US88579YAV39', 558],
  ['US14040HBZ73', 558],
  ['US456837AF06', 558],
  ['US3205511047', 67],
  ['US25154H7567', 69],
  ['US9314271084', 67],
  ['US1746101054', 65],
  ['US16411Q1013', 66],
  ['US6541101050', 67],
  ['US00081T1088', 65],
  ['US6792951054', 67],
  ['US7427181091', 65],
  ['US105756BK57', 653],
  ['US9802283088', 65],
  ['US4642878122', 69],
  ['US90400P1012', 65],
  ['US760759AU48', 558],
  ['US74347X8314', 67],
  ['CA70289T1012', 63],
  ['US9219464065', 69],
  ['BMG864081044', 361],
  ['US71647NAS80', 558],
  ['US98980F1049', 67],
  ['US46625H3654', 318],
  ['US105756BT66', 16],
  ['US29446M1027', 65],
  ['US44852D1081', 65],
  ['US88557W1018', 67],
  ['US0886061086', 65],
  ['US717081DM28', 558],
  ['US66989HAG39', 558],
  ['US22160KAM71', 558],
  ['US023135BC96', 558],
  ['US4642882579', 67],
  ['US002824BF69', 558],
  ['US24422EUU18', 558],
  ['US747525AF05', 558],
  ['US539830BH11', 558],
  ['US20030NCT63', 558],
  ['US8938702045', 65],
  ['CA80013R2063', 65],
  ['US62914V1061', 65],
  ['USP37110AK24', 3182],
  ['US29336T1007', 65],
  ['US4642864007', 69],
  ['US84790A1051', 65],
  ['US38141GFD16', 558],
  ['US3999091008', 67],
  ['US4424874018', 65],
  ['US126650CL25', 558],
  ['US09857L1089', 67],
  ['US0091581068', 65],
  ['USU37818AW82', 558],
  ['US61945C1036', 65],
  ['US22052L1044', 65],
  ['US76118Y1047', 65],
  ['US3719011096', 67],
  ['US780099CH81', 558],
  ['USP14008AC36', 558],
  ['USP16259AL02', 558],
  ['US172967JT97', 558],
  ['US72201U6385', 76],
  ['US2774321002', 65],
  ['US29261A1007', 65],
  ['US887317AV76', 558],
  ['US4523271090', 67],
  ['US4642865095', 69],
  ['US4642878619', 69],
  ['US46432F3964', 69],
  ['US9220427424', 69],
  ['US78467X1090', 69],
  ['US4943681035', 65],
  ['BMG1738J1247', 48],
  ['US4824801009', 67],
  ['US86771W1053', 67],
  ['US8334451098', 65],
  ['US69608A1088', 65],
  ['US06051GFL86', 558],
  ['US90353T1007', 65],
  ['US78454L1008', 65],
  ['US8243481061', 65],
  ['US0844231029', 65],
  ['US2605571031', 65],
  ['US5128071082', 67],
  ['US37954Y8710', 69],
  ['CA0717341071', 65],
  ['US0846701086', 65],
  ['US88034P1093', 65],
  ['US6556641008', 65],
  ['USP2195VAR61', 558],
  ['US75281A1097', 65],
  ['US5324571083', 65],
  ['US8832031012', 65],
  ['US91324P1021', 65],
  ['US6404911066', 67],
  ['US88579Y1010', 65],
  ['US6703461052', 65],
  ['US70450Y1038', 67],
  ['CA3518581051', 61],
  ['US0970231058', 65],
  ['US5486611073', 65],
  ['CA1247651088', 61],
  ['US60879E2000', 67],
  ['US7473241013', 67],
  ['US2330518539', 69],
  ['CA65389F1009', 61],
  ['US3444191064', 65],
  ['US1011371077', 65],
  ['US37950E6480', 69],
  ['US71647NAZ24', 558],
  ['US01609W1027', 318],
  ['CA11777Q2099', 61],
  ['USF2893TAM83', 558],
  ['US1101221083', 65],
  ['US71656MAF68', 558],
  ['US98421M1062', 67],
  ['US0013172053', 365],
  ['CA0679011084', 65],
  ['US97717W4481', 67],
  ['US92189H3003', 69],
  ['US02209SAV51', 558],
  ['US03522AAH32', 558],
  ['US20030NCG43', 558],
  ['US83088M1027', 67],
  ['US03754H1041', 365],
  ['US33737K2050', 67],
  ['US9173022008', 365],
  ['US7185461040', 65],
  ['US26875P1012', 65],
  ['US0556221044', 65],
  ['CA8911605092', 61],
  ['US0533321024', 65],
  ['US09247X1019', 65],
  ['CA4509131088', 61],
  ['US46137V7534', 69],
  ['US9220427754', 69],
  ['US03782L1017', 67],
  ['USC10602BA41', 558],
  ['US85205L1070', 67],
  ['US1270971039', 65],
  ['US2005251036', 67],
  ['US49456B1017', 65],
  ['US92343VCR33', 558],
  ['KYG0133A2093', 3527],
  ['US36962GW752', 558],
  ['CA09228F1036', 61],
  ['US09260D1072', 65],
  ['US651639AP18', 558],
  ['US50077LAD82', 558],
  ['US77543R1023', 67],
  ['CA60255C8850', 67],
  ['USP79171AF45', 590],
  ['US03523TBT43', 558],
  ['US37954Y8140', 67],
  ['US26924G5080', 69],
  ['US78463X5335', 69],
  ['US83404D1090', 365],
  ['US8684591089', 67],
  ['US85859N1028', 65],
  ['US91911TAE38', 558],
  ['US4642872265', 69],
  ['US9113121068', 65],
  ['USP6480JAH07', 590],
  ['CA6752221037', 61],
  ['USP0R66CAA64', 591],
  ['CA8765111064', 61],
  ['US0126531013', 65],
  ['US71647NAN93', 558],
  ['US2697961082', 67],
  ['CA05534B7604', 61],
  ['CA56501R1064', 61],
  ['CA9237251058', 61],
  ['US9485961018', 67],
  ['US98260N1081', 365],
  ['US31188V1008', 65],
  ['US1427952023', 365],
  ['US6701081092', 365],
  ['US05565A2024', 365],
  ['US29286D1054', 365],
  ['US035240AQ30', 558],
  ['US904764BC04', 558],
  ['US404280BK42', 558],
  ['US58933YBC84', 558],
  ['KYG8586D1097', 104],
  ['US4642867158', 67],
  ['KYG931751005', 104],
  ['US98423J1016', 65],
  ['US4335392027', 65],
  ['US05722G1004', 67],
  ['US50212V1008', 67],
  ['US45845P1084', 67],
  ['US56108H1059', 365],
  ['US78112J2087', 65],
  ['US37045XCX21', 558],
  ['US24422ESP50', 558],
  ['US00404A1097', 67],
  ['US03076CAG15', 558],
  ['CA6979001089', 65],
  ['US3364331070', 67],
  ['US37247D1063', 65],
  ['US83304A1060', 65],
  ['US66988N2053', 365],
  ['USU83574AC43', 558],
  ['USU78585AC73', 558],
  ['KYG037AX1015', 67],
  ['US71654QCG55', 558],
  ['USU07264AG68', 558],
  ['US88732JAY47', 558],
  ['US74975E3036', 365],
  ['US00435F3091', 365],
  ['US71654V4086', 65],
  ['US13961R1005', 365],
  ['US61770C3438', 2943],
  ['US5657881067', 67],
  ['USA9890AAA81', 558],
  ['US828807CR63', 558],
  ['US038222AL98', 558],
  ['US87236YAD04', 558],
  ['US00440EAV92', 558],
  ['US039483BL57', 558],
  ['US65339KBJ88', 558],
  ['CA8787422044', 61],
  ['US808513AU91', 558],
  ['KYG687071012', 65],
  ['US25468PDV58', 558],
  ['US4642872349', 69],
  ['US0463531089', 67],
  ['US8036071004', 67],
  ['US46428Q1094', 69],
  ['US2044481040', 65],
  ['US9229087443', 69],
  ['US46435G5320', 67],
  ['US2044291043', 65],
  ['US45384B1061', 67],
  ['US0545361075', 365],
  ['US23636T1007', 365],
  ['US5801351017', 65],
  ['US0091262024', 365],
  ['US5021172037', 365],
  ['US8269171067', 67],
  ['US2338252073', 365],
  ['US6261881063', 365],
  ['US47215P1066', 67],
  ['US7434762024', 365],
  ['CA8910546032', 61],
  ['US25157Y2028', 365],
  ['US2687801033', 365],
  ['CA29446Y5020', 61],
  ['US02081G2012', 67],
  ['CA0084741085', 61],
  ['CA6882811046', 61],
  ['CA0805581091', 365],
  ['CA92625W5072', 61],
  ['US1431301027', 65],
  ['US0326541051', 67],
  ['US03027X1000', 65],
  ['US4642888519', 896],
  ['US8725401090', 65],
  ['US6935061076', 65],
  ['US2567461080', 67],
  ['US2172041061', 67],
  ['US1491231015', 65],
  ['US11135F1012', 67],
  ['US12514G1085', 67],
  ['US4642888444', 69],
  ['US50186Q2021', 507],
  ['US78468R7888', 69],
  ['US4435731009', 65],
  ['US00214Q1040', 69],
  ['USP2253TJN02', 558],
  ['US00214Q4010', 69],
  ['USL20041AD89', 558],
  ['USU37818AR97', 558],
  ['US09075V1026', 67],
  ['US80810D1037', 67],
  ['USP6S52BAA07', 591],
  ['US8447411088', 65],
  ['USP37341AA50', 590],
  ['US8610121027', 65],
  ['KYG9830T1067', 104],
  ['US9576381092', 65],
  ['US16934Q2084', 65],
  ['US85571B1052', 65],
  ['USG9328DAP53', 558],
  ['USP06518AF40', 13],
  ['US57636Q1040', 65],
  ['US124857AR43', 558],
  ['US5951121038', 67],
  ['US17275R1023', 67],
  ['US5949181045', 67],
  ['US1912161007', 65],
  ['US2561631068', 67],
  ['US78463X5418', 69],
  ['US25459W4583', 69],
  ['US105756CC23', 3216],
  ['US12634MAE03', 558],
  ['US80105N1054', 67],
  ['CA38080W1023', 63],
  ['US4642877215', 318],
  ['CA34985Q1000', 63],
  ['US1941621039', 65],
  ['US404280BH13', 558],
  ['US29446MAD48', 558],
  ['US95000U2C66', 558],
  ['US4642877629', 69],
  ['US55024U1097', 67],
  ['USY39694AA51', 558],
  ['US92189F8178', 69],
  ['US6708515001', 365],
  ['US00206R1023', 65],
  ['USP14486AM92', 16],
  ['US251526BY45', 558],
  ['US46090E1038', 67],
  ['US46137V3574', 69],
  ['BMG210901242', 104],
  ['US48138M1053', 65],
  ['US42824C1099', 65],
  ['US48251W1045', 65],
  ['US2193501051', 65],
  ['US9297401088', 65],
  ['US4642872422', 69],
  ['US37950E1010', 69],
  ['US5949724083', 67],
  ['US8404411097', 67],
  ['US46137V3731', 69],
  ['VGG3727T1057', 613],
  ['US46137V3327', 69],
  ['US46137V2741', 69],
  ['US9219107094', 69],
  ['US3015058890', 69],
  ['US72201R8824', 69],
  ['US6742152076', 67],
  ['US92189F7915', 69],
  ['US92189F1306', 69],
  ['US92206C7719', 67],
  ['CA29764T1012', 6022],
  ['CA67077M1086', 61],
  ['VGG7823S1011', 67],
  ['US87157D1090', 67],
  ['US49271V1008', 67],
  ['US26924G8134', 69],
  ['US05946KAF84', 558],
  ['US37954Y6730', 896],
  ['US50155Q1004', 65],
  ['US92857WBQ24', 558],
  ['US92189F7758', 69],
  ['US65559D2A65', 3652],
  ['US4642866242', 69],
  ['US92204A4058', 69],
  ['US92204A7028', 69],
  ['US0321081020', 69],
  ['US78464A7147', 69],
  ['CA13708P2017', 63],
  ['CA92206N1087', 61],
  ['USG4808VAC49', 558],
  ['US205887CE05', 558],
  ['CA59126M1068', 365],
  ['US8131132065', 365],
  ['US81783H1059', 365],
  ['US9224171002', 67],
  ['US26152H3012', 65],
  ['US81762P1021', 65],
  ['US3696043013', 65],
  ['USP9308RAZ66', 590],
  ['US26924G2012', 69],
  ['US4593481082', 365],
  ['US46115H1077', 365],
  ['US48137C1080', 365],
  ['US6264251025', 365],
  ['US65558R1095', 365],
  ['US6891641010', 365],
  ['US7223041028', 67],
  ['US8792732096', 65],
  ['US78464A5992', 69],
  ['US6525262035', 67],
  ['US040114HT09', 591],
  ['US46435U3665', 69],
  ['US14149Y1082', 65],
  ['US040114HS26', 82],
  ['US040114HU71', 591],
  ['US040114HX11', 591],
  ['US92189F8822', 67],
  ['US78468R1279', 69],
  ['US03852U1060', 65],
  ['US09354A1007', 67],
  ['US0090661010', 67],
  ['US44891N2080', 67],
  ['US92719V1008', 67],
  ['USF0265PCZ92', 558],
  ['US9220426764', 67],
  ['CA0679011084', 65],
  ['US4642886463', 67],
  ['US78467V6083', 69],
  ['US4642875987', 69],
  ['US87612E1064', 65],
  ['US98980L1017', 67],
  ['US74764U2033', 365],
  ['US60741F1049', 67],
  ['US7710491033', 65],
  ['US0727433056', 365],
  ['US0492557063', 365],
  ['US1924221039', 67],
  ['US12545M2070', 365],
  ['US0003041052', 365],
  ['US03073E1055', 65],
  ['US31428X1063', 65],
  ['US98979Y1064', 365],
  ['US61022V1070', 365],
  ['US26614N1028', 65],
  ['US82622J1043', 365],
  ['USN070592100', 67],
  ['US64110W1027', 67],
  ['US9154362084', 365],
  ['US9112713022', 365],
  ['US4507371015', 365],
  ['CA66987E2069', 318],
  ['US4642874329', 67],
  ['US3742971092', 65],
  ['US05946K1016', 65],
  ['US3737371050', 65],
  ['US7220141078', 65],
  ['US172967NU15', 558],
  ['CA51669T1012', 61],
  ['US92189F8251', 69],
  ['US5007541064', 67],
  ['US02043Q1076', 67],
  ['US25243Q2057', 318],
  ['USP01012AN67', 1025],
  ['US92764N1028', 67],
  ['US1921085049', 65],
  ['US6960775020', 69],
  ['USY2749KAC46', 13],
  ['US92857W3088', 67],
  ['US3369201039', 69],
  ['US5398301094', 65],
  ['US38068T1051', 69],
  ['US7075691094', 67],
  ['US89677Q1076', 67],
  ['BMG4593F1389', 361],
  ['US2544231069', 65],
  ['US03969T1097', 67],
  ['US38141G1040', 65],
  ['US33738R7952', 535],
  ['CA3208901064', 61],
  ['US83406F1021', 67],
  ['US91912E1055', 65],
  ['CA11777Q2099', 61],
  ['US4642881829', 67],
  ['US37954Y4347', 67],
  ['US46435U1925', 69],
  ['US9229087690', 69],
  ['US1255231003', 65],
  ['US25459W8626', 69],
  ['US91086QBG29', 3182],
  ['US00768Y4531', 69],
  ['US78468R8613', 69],
  ['USP5R6DPAB67', 558],
  ['US62854AAN46', 558],
  ['US5007673065', 69],
  ['US1720621010', 67],
  ['US71645WAQ42', 558],
  ['US00215W1009', 65],
  ['US25746U1097', 65],
  ['US22822V1017', 65],
  ['US26441C2044', 65],
  ['US29250NAH89', 558],
  ['USP25619AB67', 590],
  ['CA05156X8843', 61],
  ['US82929R3049', 365],
  ['US6315122092', 365],
  ['US8038663006', 65],
  ['CA0089118776', 61],
  ['US00089H1068', 365],
  ['US4557931098', 365],
  ['US6410694060', 365],
  ['US0003752047', 365],
  ['US9898251049', 365],
  ['US54338V1017', 365],
  ['US92766K1060', 65],
  ['US83569C1027', 365],
  ['US78463X4007', 69],
  ['US4568371037', 65],
  ['US9229085538', 69],
  ['US7960502018', 507],
  ['US69343T1079', 65],
  ['US8765685024', 361],
  ['US2786421030', 67],
  ['US54951L1098', 365],
  ['US6516391066', 65],
  ['CA1366351098', 67],
  ['US172967DS78', 558],
  ['US6541061031', 65],
  ['US9578813035', 365],
  ['US4050241003', 65],
  ['US6558441084', 65],
  ['USG54897AA45', 558],
  ['US6668071029', 65],
  ['USP1000CAA29', 591],
  ['US71654QBW15', 558],
  ['US0207721095', 69],
  ['US78464A8707', 69],
  ['CA0084741085', 61],
  ['US4642871846', 69],
  ['US88033G4073', 65],
  ['US55234L1052', 67],
  ['BMG5753U1128', 67],
  ['US00650F1093', 67],
  ['US46434V7047', 67],
  ['US60871R2094', 65],
  ['US9168961038', 318],
  ['USP989MJBE04', 82],
  ['US46138E6288', 67],
  ['US8908802064', 365],
  ['US1729673418', 65],
  ['US2937921078', 65],
  ['US00445F1093', 2913],
  ['US912810FS25', 419],
  ['CA2849025093', 65],
  ['US3377381088', 65],
  ['US4642882819', 67],
  ['US71643VAB18', 558],
  ['US71647NAM11', 558],
  ['US58933Y1055', 65],
  ['USG07402DP58', 558],
  ['US62548D1000', 365],
  ['US92532F1003', 67],
  ['US46429B3096', 69],
  ['KY30744W1070', 65],
  ['US900123AT75', 653],
  ['US37960A7357', 67],
  ['US92922P1066', 65],
  ['USP989MJBL47', 558],
  ['US760942AX01', 87],
  ['US29280W1099', 65],
  ['KYG7800X1079', 104],
  ['US5854641009', 67],
  ['US9858171054', 65],
  ['US8808901081', 65],
  ['CA2926717083', 61],
  ['US90346E1038', 65],
  ['CA17253X1050', 61],
  ['US828807CV75', 558],
  ['US26078JAC45', 558],
  ['US855244AQ29', 558],
  ['US25468PDF09', 558],
  ['US4385161066', 67],
  ['US14040HBJ32', 558],
  ['US33734X8469', 67],
  ['US26922A2895', 69],
  ['US4642874089', 69],
  ['US871829AZ02', 558],
  ['USP1047VAF42', 558],
  ['US35671D8570', 65],
  ['BMG0403V2062', 104],
  ['US51817R1068', 365],
  ['US8816242098', 65],
  ['US4642866085', 69],
  ['US85771PAK84', 558],
  ['US98138H1014', 67],
  ['BMG169621056', 65],
  ['US43300A2033', 65],
  ['US9831341071', 67],
  ['US2921041065', 65],
  ['US0234361089', 67],
  ['US8574771031', 65],
  ['US20825C1045', 65],
  ['US1667641005', 65],
  ['US00751Y1064', 65],
  ['US6092071058', 67],
  ['US8168501018', 67],
  ['US4642874659', 69],
  ['US64110D1046', 67],
  ['US0640581007', 65],
  ['US1924461023', 67],
  ['US7757812067', 365],
  ['US8190471016', 65],
  ['US92343E1029', 67],
  ['US38268T1034', 67],
  ['US2315611010', 65],
  ['US00676P1075', 67],
  ['US4642873909', 69],
  ['US23331A1097', 65],
  ['USG2519YAA67', 558],
  ['US40412C1018', 65],
  ['US74762E1029', 65],
  ['US75689M1018', 67],
  ['US2371941053', 65],
  ['CA00830W1059', 5112],
  ['US00768Y4952', 69],
  ['US3896371099', 365],
  ['US09073M1045', 67],
  ['USL00849AA47', 558],
  ['CA82509L1076', 61],
  ['KYG1674K1013', 104],
  ['CA8946478259', 61],
  ['US2788651006', 65],
  ['US6745991058', 65],
  ['US4642898427', 69],
  ['CA66510M2040', 66],
  ['US8175651046', 65],
  ['US9139031002', 65],
  ['US09061H3075', 67],
  ['US68389X1054', 65],
  ['US6700024010', 67],
  ['US0404131064', 65],
  ['US86562MBP41', 558],
  ['US4642877884', 69],
  ['US40054A1088', 65],
  ['US2910111044', 65],
  ['US046353AL27', 558],
  ['US5303073051', 67],
  ['US8923313071', 65],
  ['KYG5307W1015', 123],
  ['US0268747849', 65],
  ['US7672041008', 318],
  ['US7134481081', 67],
  ['US949746SH57', 558],
  ['US7170811035', 65],
  ['US369604BN27', 558],
  ['KYG851581069', 67],
  ['KYG875721634', 104],
  ['US40434L1052', 65],
  ['US4642873099', 69],
  ['US71654QDB59', 558],
  ['US7244791007', 65],
  ['BMG4035L1155', 1115],
  ['US6934751057', 65],
  ['US0042251084', 67],
  ['CA15135U1093', 61],
  ['US90138F1021', 65],
  ['US26142V1052', 67],
  ['US0321088058', 69],
  ['US94419L1017', 65],
  ['US92763W1036', 65],
  ['US2575541055', 67],
  ['US81141R1005', 65],
  ['US949746RW34', 558],
  ['US822582BD31', 558],
  ['US02364W1053', 2913],
  ['US67066G1040', 67],
  ['US37954Y7159', 67],
  ['KYG4100M1050', 104],
  ['US46137V7203', 69],
  ['US74347B1695', 69],
  ['USP1265VAD49', 558],
  ['US23804L1035', 67],
  ['USP3772WAF97', 558],
  ['US4642877546', 896],
  ['US37950E3339', 69],
  ['US1729674242', 65],
  ['US97717X5529', 69],
  ['US4642865822', 69],
  ['CA7751092007', 61],
  ['US97717W8516', 69],
  ['CA6445351068', 61],
  ['US71654QBH48', 558],
  ['US44980X1090', 67],
  ['US46123T1016', 365],
  ['US74347W8828', 69],
  ['KYG810431042', 104],
  ['US40049J2069', 65],
  ['US3984384087', 67],
  ['US50048H1014', 365],
  ['US45104G1040', 65],
  ['US4642884484', 896],
  ['US33616C1009', 365],
  ['US2972842007', 365],
  ['US78464A3005', 896],
  ['US55354G1004', 65],
  ['US78409V1044', 65],
  ['US6153691059', 65],
  ['US28176E1082', 65],
  ['US33737A1088', 67],
  ['US37954Y3844', 67],
  ['US2566771059', 65],
  ['US5117951062', 67],
  ['US01609WAT99', 558],
  ['CA45232V1067', 61],
  ['US6819191064', 65],
  ['US02209S1033', 65],
  ['US8794338298', 65],
  ['US5006432000', 65],
  ['US38141GVX95', 558],
  ['CA44054J3091', 61],
  ['US00214Q7088', 69],
  ['US98422D1054', 65],
  ['US00214Q5009', 896],
  ['US4642887297', 69],
  ['CA13765L1013', 365],
  ['US97717Y6914', 67],
  ['US46429B6636', 69],
  ['US4642895290', 67],
  ['US46434V1008', 67],
  ['US8740391003', 65],
  ['CA5914081099', 365],
  ['US36467W1099', 65],
  ['US12468P1049', 65],
  ['US46137V1594', 69],
  ['US46137V1008', 69],
  ['US78464A2015', 69],
  ['US4500561067', 67],
  ['US70614W1009', 67],
  ['US4642881746', 67],
  ['US37950E3412', 69],
  ['US74624M1027', 65],
  ['US8486371045', 67],
  ['US8256901005', 65],
  ['US7665596034', 67],
  ['US09061G1013', 67],
  ['US36962GXZ26', 558],
  ['US023135BZ81', 558],
  ['US29446MAF95', 558],
  ['US871829BL07', 558],
  ['US0067542045', 365],
  ['US07556Q8814', 65],
  ['US2042803096', 365],
  ['US1550382014', 65],
  ['US46434G7723', 69],
  ['US30212P3038', 67],
  ['US80007R1059', 365],
  ['US5658491064', 65],
  ['US46137V1180', 69],
  ['US14912L6C08', 558],
  ['US037833AS94', 558],
  ['US031162BV19', 558],
  ['US18915M1071', 65],
  ['CA29873T3073', 61],
  ['US96924N1000', 67],
  ['US60783X1046', 67],
  ['US747262AS23', 558],
  ['US854502AL57', 558],
  ['US0605051046', 65],
  ['US031162CU27', 558],
  ['US89236TGU34', 558],
  ['US46647PAX42', 558],
  ['US701094AN45', 558],
  ['US907818FB91', 558],
  ['US97717X7012', 69],
  ['US0917491013', 365],
  ['US3021301094', 65],
  ['US00214Q8078', 896],
  ['US53656F7895', 69],
  ['US78463V1070', 69],
  ['US46435U7138', 896],
  ['US33939L7955', 69],
  ['CA69841K1030', 63],
  ['US36870W1009', 67],
  ['US05964H1059', 318],
  ['US4642886208', 67],
  ['US7766961061', 67],
  ['US46434V6395', 69],
  ['US4642866655', 69],
  ['US92189F8418', 69],
  ['US03152W1099', 67],
  ['US2330518794', 69],
  ['US98585N1063', 65],
  ['US37950E4089', 69],
  ['US9291601097', 65],
  ['USP3063DAB84', 591],
  ['US9256521090', 65],
  ['CA75381M1023', 365],
  ['US42809H1077', 65],
  ['US37045VAP58', 558],
  ['US715638AS19', 3182],
  ['US7427181091', 65],
  ['US33733E3027', 69],
  ['US37954Y3927', 67],
  ['KYG525621408', 104],
  ['US8793601050', 65],
  ['US74347G4322', 1596],
  ['BMG6845B1046', 120],
  ['US7475251036', 67],
  ['BMG670131058', 699],
  ['US36465A1097', 69],
  ['US92189F6438', 896],
  ['US8725901040', 67],
  ['US0567521085', 67],
  ['US10552T1079', 65],
  ['US19260Q1076', 67],
  ['US75886F1075', 67],
  ['US74347B4251', 69],
  ['US92556V1061', 67],
  ['US9497461015', 65],
  ['US37954Y8306', 69],
  ['US81686C1045', 65],
  ['US87155N1090', 365],
  ['US0968132094', 365],
  ['US69368G1058', 365],
  ['US83272W1062', 365],
  ['US6068221042', 65],
  ['US4381283088', 65],
  ['US6546241059', 365],
  ['US48123KAE64', 558],
  ['US86562M2098', 65],
  ['US38141GVR28', 558],
  ['US369550BC16', 558],
  ['US20030NDW83', 558],
  ['US76954A1034', 67],
  ['US040114HV54', 590],
  ['US00214Q3020', 896],
  ['USN5276YAD87', 558],
  ['US46428R1077', 69],
  ['US251525AX97', 558],
  ['US78410G1040', 67],
  ['US29444U7000', 67],
  ['KYG5S74L1067', 67],
  ['US036752AC75', 558],
  ['US33733B1008', 69],
  ['US25809K1051', 67],
  ['US594918CE21', 558],
  ['US9255501051', 67],
  ['US33813J1060', 65],
  ['US46625H1005', 65],
  ['US1124631045', 65],
  ['US81180WAR25', 558],
  ['US3434121022', 65],
  ['KYG011981035', 104],
  ['US55302T2042', 507],
  ['US456837AH61', 558],
  ['US37954Y8488', 69],
  ['US26924G4091', 69],
  ['US46120E6023', 67],
  ['CA49374L3065', 365],
  ['US5186132032', 67],
  ['US19243N1063', 365],
  ['US9842411095', 67],
  ['US38526M1062', 67],
  ['US92552V1008', 67],
  ['US59410T1060', 365],
  ['US92189F1066', 69],
  ['US37954Y8553', 69],
  ['US4642861037', 69],
  ['US61166WAU53', 558],
  ['US9229087518', 69],
  ['US5733311055', 67],
  ['US10316T1043', 65],
  ['US68389XBT19', 558],
  ['US46121Y2019', 65],
  ['US404280BZ11', 558],
  ['US05526DAZ87', 558],
  ['US4642868065', 69],
  ['US0465131078', 67],
  ['US6993743029', 2779],
  ['US7501021056', 67],
  ['US28249U1051', 67],
  ['US03769M1062', 65],
  ['US45867G1013', 67],
  ['US6540901096', 365],
  ['US8248414075', 365],
  ['US437076BK73', 558],
  ['US8522341036', 65],
  ['US88031M1099', 318],
  ['US02209SBF92', 558],
  ['US172967NL16', 558],
  ['US24422EVK27', 558],
  ['US46647PDE34', 558],
  ['US4642887453', 69],
  ['US37045XCK00', 558],
  ['US30303M1027', 67],
  ['US7509171069', 67],
  ['USN070592100', 67],
  ['US00773T1016', 65],
  ['US37950E2596', 69],
  ['US4642887370', 69],
  ['KYG9884T1013', 104],
  ['US10501E2019', 535],
  ['US10921T1016', 67],
  ['US4642873412', 69],
  ['US00287Y1091', 65],
  ['US4642873255', 69],
  ['US46137V5710', 67],
  ['US2948216088', 67],
  ['US172967KN09', 558],
  ['US4642882249', 67],
  ['US6402681083', 67],
  ['BMG067231032', 48],
  ['US56585ABH41', 558],
  ['US71654QBV32', 558],
  ['US03753U1060', 67],
  ['US6245801062', 65],
  ['CA85207K1075', 69],
  ['KYG8208B1014', 104],
  ['CA4436281022', 61],
  ['US78464A5083', 69],
  ['US05968L1026', 65],
  ['US92857WBN92', 558],
  ['CA07317Q1054', 61],
  ['US74347B2016', 896],
  ['US3695501086', 65],
  ['US382550BG56', 558],
  ['US92189F2056', 69],
  ['US74348A4673', 896],
  ['US8793822086', 318],
  ['US4642875565', 67],
  ['BMG942051043', 104],
  ['US3703341046', 65],
  ['US3665051054', 67],
  ['US8753722037', 67],
  ['US78464A5810', 69],
  ['USG3812BAB65', 558],
  ['US2521311074', 67],
  ['US12047B1052', 67],
  ['US87974R2085', 365],
  ['US78464A7899', 318],
  ['US7163821066', 67],
  ['US82575P1075', 318],
  ['US94106L1098', 65],
  ['US48123V1026', 67],
  ['VGG0411N1050', 3527],
  ['US6174681030', 65],
  ['US72201H1086', 65],
  ['US4233253073', 365],
  ['USU07265AF50', 558],
  ['US46138G5080', 69],
  ['US3825501014', 67],
  ['US9807451037', 67],
  ['US7562552049', 365],
  ['US83175M2052', 65],
  ['US78467K1079', 365],
  ['US83238P2039', 365],
  ['US5394391099', 318],
  ['US45262P1021', 365],
  ['US4042804066', 318],
  ['US05523R1077', 365],
  ['US83546A2033', 365],
  ['CA6811031070', 63],
  ['US3755581036', 67],
  ['US8425871071', 65],
  ['US64157F1030', 65],
  ['US4642885218', 69],
  ['US6840601065', 65],
  ['US105756BV13', 653],
  ['US26853E1029', 67],
  ['US46429B6065', 69],
  ['CA0496AP2026', 63],
  ['US040114HW38', 591],
  ['US8552441094', 67],
  ['USG3980PAA33', 558],
  ['US74251VAR33', 558],
  ['US97717W2089', 80],
  ['US74347R1317', 69],
  ['USP989MJBR17', 558],
  ['US191216CL26', 558],
  ['US74347G3662', 69],
  ['US0936881095', 110],
  ['US88554D2053', 65],
  ['US29766LAA44', 186],
  ['US4642865178', 69],
  ['CA29258Y1034', 65],
  ['USP989MJBS99', 558],
  ['US9741551033', 67],
  ['US91167Q1004', 69],
  ['US2264061068', 67],
  ['US28106W1036', 67],
  ['US4523081093', 65],
  ['US79466L3024', 65],
  ['CA8676EP1086', 67],
  ['CA6979001089', 65],
  ['US5917741044', 65],
  ['US4642878049', 318],
  ['US45667G1031', 67],
  ['US72919P2020', 67],
  ['US8962881079', 65],
  ['US55616P1049', 65],
  ['US05606L1008', 365],
  ['US84265VAH87', 558],
  ['US3719271047', 65],
  ['US6549022043', 318],
  ['US51509P1030', 67],
  ['US16934W1062', 67],
  ['CA8525403017', 61],
  ['US22113B1035', 65],
  ['US67059N1081', 67],
  ['US105756BF62', 16],
  ['US45167R1041', 65],
  ['US5915202007', 65],
  ['CA8672241079', 61],
  ['US9029733048', 65],
  ['US4642868222', 69],
  ['US4642887602', 69],
  ['US4642867729', 69],
  ['US02079K1079', 67],
  ['US46429B4169', 896],
  ['US4642875235', 67],
  ['US9229083632', 69],
  ['US84756T1060', 361],
  ['US08862E1091', 67],
  ['US02665WDD02', 558],
  ['US4642875078', 69],
  ['US4661101034', 365],
  ['US65339F1012', 65],
  ['US3896381072', 365],
  ['US92189H8051', 69],
  ['US4642864262', 67],
  ['US92189F3534', 69],
  ['US7181721090', 65],
  ['KYG9344R2991', 9760],
  ['US30212W1009', 67],
  ['US1347481020', 67],
  ['US4642876555', 318],
  ['US2330515071', 69],
  ['US50186V1026', 65],
  ['US91347P1057', 67],
  ['US0231351067', 67],
  ['US5962781010', 67],
  ['KYG242081290', 2860],
  ['BMG507361001', 120],
  ['US78463X7562', 69],
  ['US9273201015', 365],
  ['US8261975010', 365],
  ['US0727303028', 365],
  ['US0552625057', 365],
  ['US92189H6071', 69],
  ['CA00900Q1037', 61],
  ['US5004723038', 65],
  ['US0092791005', 365],
  ['US2515661054', 365],
  ['US9219438580', 69],
  ['US54150E1047', 65],
  ['US7237871071', 65],
  ['US33733E2037', 69],
  ['US82982T1060', 67],
  ['US58733R1023', 67],
  ['US33738R8521', 67],
  ['US5367971034', 65],
  ['US74347X8496', 69],
  ['US02079K3059', 67],
  ['US78464A8889', 69],
  ['US4103451021', 65],
  ['KYG017191142', 104],
  ['US46429B2676', 69],
  ['US4642868719', 69],
  ['US4642864759', 69],
  ['US92204A3068', 69],
  ['US78464A7634', 69],
  ['US0594603039', 318],
  ['US72201R7750', 65],
  ['US00206RMM15', 558],
  ['CA92707Y1088', 67],
  ['US48203R1041', 65],
  ['US78464A6982', 69],
  ['US1266501006', 65],
  ['US5529531015', 65],
  ['US23304Y1001', 365],
  ['US46435G2434', 67],
  ['US2515421061', 365],
  ['US30226D1063', 67],
  ['US4642888022', 69],
  ['US03938L2034', 318],
  ['US67092P6079', 896],
  ['US78486Q1013', 365],
  ['US16411R2085', 318],
  ['US92345Y1064', 67],
  ['US7739031091', 65],
  ['US26922A8421', 69],
  ['US9024941034', 65],
  ['US2473617023', 65],
  ['US45337C1027', 67],
  ['US6174464486', 65],
  ['US46434V8862', 69],
  ['US4642862852', 896],
  ['KYG982391099', 67],
  ['US46435G1022', 896],
  ['US46138E8003', 69],
  ['USJ57160DX83', 558],
  ['US92243A2006', 67],
  ['CA9279263037', 69],
  ['CA6871961059', 699],
  ['US1512908898', 318],
  ['US00846U1016', 65],
  ['US0028241000', 65],
  ['US9842451000', 65],
  ['US36165L1089', 67],
  ['US4771431016', 67],
  ['US00724F1012', 67],
  ['CA00461M1032', 61],
  ['US0079031078', 67],
  ['US2358511028', 65],
  ['US4642861789', 896],
  ['US22160K1051', 67],
  ['US0010551028', 65],
  ['US42307TAG31', 558],
  ['BMG9456A1009', 67],
  ['US4128221086', 65],
  ['US3383071012', 67],
  ['US4642866408', 69],
  ['US0846707026', 65],
  ['US45773H2013', 67],
  ['US60770K1079', 67],
  ['US1920101060', 2913],
  ['US780097AZ42', 558],
  ['US00848K1016', 69],
  ['USP3711HAF66', 558],
  ['US7672921050', 67],
  ['US4642862514', 896],
  ['US81369Y8600', 69],
  ['US78463X2027', 69],
  ['US47759T1007', 65],
  ['USU75000BJ45', 558],
  ['US0258161092', 65],
  ['US92189F6768', 67],
  ['US85208P1057', 76],
  ['US38059T1060', 318],
  ['US78468R5569', 69],
  ['US2254011081', 6829],
  ['US4278661081', 65],
  ['US68389XAW56', 558],
  ['US8718291078', 65],
  ['US05967A1079', 65],
  ['US6974351057', 67],
  ['US4370761029', 65],
  ['US105756BX78', 16],
  // replacements for changed ISINs
  ['CH1276062754', 4],
  ['CL0002426188', 84],
  ['NL0015001FS8', 1058],
  ['FR001400J770', 25],
  ['FR0013393345', 3313],
  ['LU1315124062', 3313],
  ['LU1315125119', 3313],
  ['LU1088685117', 3313],
  ['FR0014005997', 3313],
  ['LU2051741416', 3313],
  ['US09789C7700', 69],
  ['US4500473032', 65],
  ['US53933L2034', 67]
]);
